/* ASSETS  */
import boutonLire from 'assets/img/bouton_lire.png';
import boutonLireHoover from 'assets/img/bouton_lire_hoover.png';
import boutonRegarder from 'assets/img/bouton_regarder.png';
import boutonRegarderHoover from 'assets/img/bouton_regarder_hoover.png';
import boutonCoeur from 'assets/img/bouton_coeur.png';
import boutonCoeurHoover from 'assets/img/bouton_coeur_hoover.png';
import homeIconBlack from 'assets/img/home-icon-black.png';

import blockBlancFakeChoiceSmall from 'assets/img/bloc_blanc_fakechoice_small.png';
// import blockBlancFakeChoiceMedium from 'assets/img/bloc_blanc_fakechoice_medium.png';
import blockBlancFakeChoiceLarge from 'assets/img/bloc_blanc_fakechoice_large.png';

/* FOREGROUND */
import portrait from 'assets/img/journey/hassan/portrait.png';
// import tanks from 'assets/img/journey/hassan/tanks.png';
import tank_1 from 'assets/img/journey/hassan/tank_1.png';
import tank_2 from 'assets/img/journey/hassan/tank_2.png';
import tank_3 from 'assets/img/journey/hassan/tank_3.png';
import tank_4 from 'assets/img/journey/hassan/tank_4.png';
import phoneClear from 'assets/img/journey/hassan/phoneClear.png';
import phoneFill from 'assets/img/journey/hassan/phoneFill.png';
import phoneHalf from 'assets/img/journey/hassan/phoneHalf.png';

import epilogue_silhouette from 'assets/img/journey/hassan/epilogue_silhouette.png';

import sequenceShared1 from 'assets/img/journey/hassan/sequenceShared1.png';
import sequenceShared2 from 'assets/img/journey/hassan/sequenceShared2.png';
import sequenceShared3 from 'assets/img/journey/hassan/sequenceShared3.png';
import sequenceShared4 from 'assets/img/journey/hassan/sequenceShared4.png';

import sequenceNotShared1 from 'assets/img/journey/hassan/sequenceNotShared1.png';
import sequenceNotShared2 from 'assets/img/journey/hassan/sequenceNotShared2.png';
import sequenceNotShared3 from 'assets/img/journey/hassan/sequenceNotShared3.png';

import famille from 'assets/img/journey/hassan/famille.png';
import phoneWhatsapp from 'assets/img/journey/hassan/phoneWhatsapp.png';

import PhylactereHassan from 'assets/img/journey/hassan/phylactere_etudierL.png';

/* BACKGROUND */
import baseBackgroundImg from 'assets/img/home-background-min.jpg';
import backgoundPurple from 'assets/img/backgound_purple.jpg';
import hassanBG1 from 'assets/img/journey/hassan/DE3N2Y-min.jpg';
import hassanBG2 from 'assets/img/journey/hassan/2CDN1JD-min.jpg';
import hassanBG7 from 'assets/img/journey/hassan/2CBDBK5.jpg';
import hassanBG8 from 'assets/img/journey/hassan/FWX4GM.jpeg';
import hassanBG9 from 'assets/img/journey/hassan/2AB5JNR.jpg';
import hassanBG10 from 'assets/img/journey/hassan/S3275H-min.jpg';
import hassanBG11 from 'assets/img/journey/hassan/H60954.jpg';
import hassanBG12 from 'assets/img/journey/hassan/TXNE40-min.jpeg';
import hassanBG13 from 'assets/img/journey/hassan/PHY967-min.jpeg';
import hassanBG14 from 'assets/img/journey/hassan/D2G5AR-min.jpeg';
import hassanBG15 from 'assets/img/journey/hassan/F5687K-min.jpg';
import hassanBG16 from 'assets/img/journey/hassan/hassan_service_des_etrangers.jpg';
import hassanBG18 from 'assets/img/journey/hassan/parcours_3_lettre_ofice_etrangers-min.jpg';
import hassanBG19 from 'assets/img/journey/hassan/2BK96PF-min.jpeg';
import hassanBG20 from 'assets/img/journey/hassan/A4T8Y1-min.jpg';
import hassanBG21 from 'assets/img/journey/hassan/shutterstock_266821754-min.jpg';
import hassanBG23 from 'assets/img/journey/hassan/H9FA4A-min.jpeg';

/* MAPS */
import mapSyrieTurquie from 'assets/img/journey/hassan/syrie_carte_1-min_FR.png';
import mapTurquieEurope from 'assets/img/journey/hassan/syrie_carte_2-min_FR.png';

import mapIncoherence1 from 'assets/img/journey/hassan/hassan_ecran_adieux_salim_FR.png';

/* sounds */
import soundIntro from 'assets/sounds/hassan_fr/HASSAN_FR_INTRO.mp3';
import HASSAN_FR_SEQ01 from 'assets/sounds/hassan_fr/HASSAN_FR_SEQ01.mp3';
import HASSAN_FR_SEQ02 from 'assets/sounds/hassan_fr/HASSAN_FR_SEQ02.mp3';
import HASSAN_FR_SEQ03 from 'assets/sounds/hassan_fr/HASSAN_FR_SEQ03.mp3';
import HASSAN_FR_SEQ04 from 'assets/sounds/hassan_fr/HASSAN_FR_SEQ04.mp3';
import HASSAN_FR_SEQ05 from 'assets/sounds/hassan_fr/HASSAN_FR_SEQ05.mp3';
import HASSAN_FR_SEQ06 from 'assets/sounds/hassan_fr/HASSAN_FR_SEQ06.mp3';
import HASSAN_FR_SEQ07 from 'assets/sounds/hassan_fr/HASSAN_FR_SEQ07.mp3';
import HASSAN_FR_SEQ08 from 'assets/sounds/hassan_fr/HASSAN_FR_SEQ08.mp3';
import HASSAN_FR_SEQ09 from 'assets/sounds/hassan_fr/HASSAN_FR_SEQ09.mp3';
import HASSAN_FR_SEQ10 from 'assets/sounds/hassan_fr/HASSAN_FR_SEQ10.mp3';
import HASSAN_FR_SEQ11 from 'assets/sounds/hassan_fr/HASSAN_FR_SEQ11.mp3';
import HASSAN_FR_SEQ12 from 'assets/sounds/hassan_fr/HASSAN_FR_SEQ12.mp3';
import HASSAN_FR_SEQ13 from 'assets/sounds/hassan_fr/HASSAN_FR_SEQ13.mp3';
import HASSAN_FR_SEQ14 from 'assets/sounds/hassan_fr/HASSAN_FR_SEQ14.mp3';
import HASSAN_FR_SEQ15 from 'assets/sounds/hassan_fr/HASSAN_FR_SEQ15.mp3';
import HASSAN_FR_SEQ16 from 'assets/sounds/hassan_fr/HASSAN_FR_SEQ16.mp3';
import HASSAN_FR_SEQ17 from 'assets/sounds/hassan_fr/HASSAN_FR_SEQ17.mp3';
import HASSAN_FR_SEQ18 from 'assets/sounds/hassan_fr/HASSAN_FR_SEQ18.mp3';
import HASSAN_FR_SEQ19 from 'assets/sounds/hassan_fr/HASSAN_FR_SEQ19.mp3';
import HASSAN_FR_SEQ20 from 'assets/sounds/hassan_fr/HASSAN_FR_SEQ20.mp3';
import HASSAN_FR_SEQ21 from 'assets/sounds/hassan_fr/HASSAN_FR_SEQ21.mp3';
import HASSAN_FR_SEQ22 from 'assets/sounds/hassan_fr/HASSAN_FR_SEQ22.mp3';
import HASSAN_FR_SEQ23 from 'assets/sounds/hassan_fr/HASSAN_FR_SEQ23.mp3';

import HASSAN_FR_EPILOG1 from 'assets/sounds/hassan_fr/HASSAN_FR_EPILOG1.mp3';
import HASSAN_FR_EPILOG2 from 'assets/sounds/hassan_fr/HASSAN_FR_EPILOG2.mp3';

import HASSAN_FR_EPILOGFIN1 from 'assets/sounds/hassan_fr/HASSAN_FR_EPILOGFIN1.mp3';
import HASSAN_FR_EPILOGFIN2 from 'assets/sounds/hassan_fr/HASSAN_FR_EPILOGFIN2.mp3';

import { getYoutubeIframe, colors } from './utils';

// import HASSAN_FR_?? from 'assets/sounds/hassan_fr/HASSAN_FR_unkown.mp3';

// import blocNoir from 'assets/img/bloc_noir-min.png';
// import blocNoirHover from 'assets/img/block_noir_hoover-min.png';

const choiceButtonStyle = { marginLeft: 'auto', marginRight: 'auto', marginTop: 20, padding: '30px!important', minHeight: 100, maxWidth: 250, color: 'white' };

const otherChoiceButtonStyle = {
  ...choiceButtonStyle,
  fontSize: '1.5rem!important',
  fontWeight: '700!important',
  color: 'black!important',
  maxWidth: 200,
  backgroundImage: `url(${blockBlancFakeChoiceSmall})!important`,
  '&:hover': { textDecoration: 'underline' },
};

const base_choice_style = {
  containerStyle: {
    backgroundColor: 'white',
    color: 'black',
  },
  fixedImageBackground: portrait,
  fixedImageBackgroundStyle: {
    backgroundSize: '35% auto',
    backgroundPosition: '95% center',
  },

  homeIcon: homeIconBlack,
  homeHoverIcon: homeIconBlack,

  contentStyle: {
    width: '50%',
    maxWidth: '1150px',
    marginLeft: '10%',
  },
};

const epilogeAnimationTiming = 2500;
const epilogeSoundAdditionalDelay = 1500;
const base_epilogue = {
  type: 'epilogue',
  background: { src: backgoundPurple },
  foreground: {
    src: epilogue_silhouette,
    // style: { height: '80vh', position: 'relative', top: '10vh', left: '0vw', opacity: 1, transition: 'transform linear', transform: 'scale(1)' }, //, transformOrigin: '27.5% 65.1%'
    style: { height: '80vh', position: 'relative', top: '10vh', left: '0vw', opacity: 0, animationFillMode: 'forwards', animationTimingFunction: 'linear', transform: 'scale(.7) translateX(-30%)' }, //, transformOrigin: '27.5% 65.1%'
    animations: [{ delay: 250, style: { animationName: 'opacityNoneToFull', animationDuration: `${epilogeAnimationTiming}ms` } }],
  },
};

export const hassan_fr = {
  description: {
    name: 'Hassan',
    age: '17',
    city: 'Lattaquié',
    country: 'Syrie',
    text: "La ville où je vis, Lattaquié, est à mon avis la plus belle de Syrie. J’y vis avec mon père, ma mère, ma sœur. J’ai aussi un frère mais je ne l’ai plus vu depuis longtemps. Il est dans l'armée. Debout sur mon balcon, je peux voir les montagnes et sentir la mer et rêver à toutes les choses qui y vivent. Mon rêve est de devenir biologiste. Je vais étudier à Damas, la capitale. Ma sœur se moque souvent de moi, mais j'ai un peu peur d'être loin de ma famille et de mes amis. Ils vont tellement me manquer...",
    sound: soundIntro,
  },
  additionalLoad: [
    { type: 'img', src: backgoundPurple },
    { type: 'img', src: tank_1 },
    { type: 'img', src: tank_2 },
    { type: 'img', src: tank_3 },
    { type: 'img', src: tank_4 },
    { type: 'img', src: phoneClear },
    { type: 'img', src: phoneFill },
    { type: 'img', src: phoneHalf },
    { type: 'img', src: portrait },
    { type: 'img', src: sequenceShared1 },
    { type: 'img', src: sequenceShared2 },
    { type: 'img', src: sequenceShared3 },
    { type: 'img', src: sequenceShared4 },
    { type: 'img', src: sequenceNotShared1 },
    { type: 'img', src: sequenceNotShared2 },
    { type: 'img', src: sequenceNotShared3 },
    { type: 'img', src: epilogue_silhouette },
    { type: 'img', src: famille },
  ],
  steps: [
    {
      id: 'HASSAN 01',
      type: 'sequence',
      sound: HASSAN_FR_SEQ01,
      sound_delay: 50,
      sequence: [
        { type: 'text', text: '\u00c9t\u00e9 2011. Je viens de recevoir mon dipl\u00f4me. ', delay: 3210 },
        { type: 'text', text: 'Avec mes amis, on va aller au parc pr\u00e8s de la mosqu\u00e9e pour faire la f\u00eate.', delay: 3910 },
        { type: 'text', text: 'Presque toute la classe sera l\u00e0.', delay: 3060 },
        { type: 'text', text: "Depuis des mois, nous parlons sans arr\u00eat de nos projets d'avenir. ", delay: 1900 },
        { type: 'text', text: "Beaucoup de mes camarades de classe vont faire l'arm\u00e9e. ", delay: 3040 },
        { type: 'text', text: 'En Syrie, il y a le service militaire obligatoire si vous ne poursuivez pas vos \u00e9tudes. ', delay: 2960 },
        { type: 'text', text: "Et m\u00eame si j'ai attendu ce moment avec impatience, j'ai un double sentiment. ", delay: 4040 },
        { type: 'text', text: "C'est tr\u00e8s agit\u00e9 ici depuis un moment maintenant.", delay: 4880 },
        { type: 'text', text: 'Dans tout le pays, les gens protestent contre le gouvernement.', delay: 2130 },
        { type: 'text', text: "J'ai peur de laisser mes parents et ma s\u0153ur derri\u00e8re moi \nquand je partirai pour Damas.", delay: 3050 },
        { type: 'text', text: '', delay: 5900 },
        { type: 'goToNext', delay: 3080 },
      ],
      background: {
        src: hassanBG1,
        style: { width: '120vw', position: 'relative', left: '-20vw' }, // transition: 'transform linear'
        animations: [
          { delay: 50, style: { animationDuration: '41110ms', animationName: 'translateX0To20vw' } }, // height: '120%', top: '-10%', width: '120%', left: '-10%'
        ],
      },
      // textBackgroundColor: '#af8d69',
      nextStepId: 'HASSAN 02',
    },
    {
      id: 'HASSAN 02',
      type: 'sequence',
      sound: HASSAN_FR_SEQ02,
      sound_delay: 50,
      sequence: [
        { type: 'text', text: 'En arrivant dans le parc, il y avait un groupe de manifestants \u00e0 la mosqu\u00e9e.', delay: 2140 },
        { type: 'text', text: "Je savais qu'il y aurait une manifestation aujourd'hui.", delay: 4030 },
        { type: 'text', text: "Mon oncle m'avait m\u00eame invit\u00e9 \u00e0 venir. ", delay: 2830 },
        { type: 'text', text: 'Il ne comprend pas pourquoi nous ne sortons pas tous pour manifester. ', delay: 2140 },
        { type: 'text', text: "M\u00eame si j'ai beaucoup de respect pour lui, \nje pense qu'il est plus s\u00fbr de ne pas le faire. ", delay: 3060 },
        { type: 'text', text: 'Je ne veux pas risquer mon avenir. ', delay: 4010 },
        { type: 'text', text: "Les gens brandissent des banderoles en l'air \nen appelant \u00e0 plus de libert\u00e9 et de d\u00e9mocratie.", delay: 1830 },
        { type: 'text', text: '', delay: 6020 },
        { type: 'goToNext', delay: 1150 },
      ],
      background: {
        src: hassanBG2,
        style: {},
        animations: [{ delay: 50, style: { animationName: 'scale20', animationDuration: '27160ms' } }],
      },
      // textBackgroundColor: '#af8d69',
      nextStepId: 'HASSAN 03',
    },
    {
      id: 'HASSAN 03',
      type: 'sequence',
      sound: HASSAN_FR_SEQ03,
      sound_delay: 50,
      sequence: [
        { type: 'text', text: 'Soudain, on entend des tanks qui se rapprochent. ', delay: 3200 },
        { type: 'text', text: 'Les gens sortent et commencent \u00e0 tirer. ', delay: 2020 },
        { type: 'text', text: "Les gens crient, pleurent, s'enfuient. C'est hallucinant&thinsp;! ", delay: 1960 },
        { type: 'text', text: "Comme par r\u00e9flexe, j'ai sorti mon t\u00e9l\u00e9phone portable \net j'ai commenc\u00e9 \u00e0 tout filmer.", delay: 3030 },
        { type: 'text', text: '', delay: 4940 },
        { type: 'goToNext', delay: 2960 },
      ],
      background: {
        src: baseBackgroundImg,
        // style: {}, //transition: 'left linear, top linear, width linear, height linear'
        // animations: [
        //   { delay: 50, style: { animationDuration: '37120ms', animationName: 'scale20' } }, // height: '120%', top: '-10%', width: '120%', left: '-10%'
        // ],
      },
      foreground: {
        src: tank_1,
        style: { height: '30vh', opacity: 0, transform: 'translate(calc((100vw - 75vh)/2) , -15vh)' },
        animations: [
          { delay: 3000, style: { animationName: 'opacityNoneToFull', animationDuration: '500ms' } },
          { delay: 2500, style: { animationName: 'opacityFullToNone', animationDuration: '500ms' } },
          { delay: 500, src: tank_2, style: { height: '40vh', transform: 'translate(calc((100vw - (1.8 * 40vh))/2) , -5vh)', animationName: 'opacityNoneToFull', animationDuration: '500ms' } },
          { delay: 3000, src: tank_2, style: { height: '40vh', transform: 'translate(calc((100vw - (1.8 * 40vh))/2) , -5vh)', animationName: 'opacityFullToNone', animationDuration: '500ms' } },
          { delay: 500, src: tank_3, style: { height: '40vh', transform: 'translate(0 , 5vh)', animationName: 'opacityNoneToFull', animationDuration: '500ms' } },
          { delay: 4500, src: tank_3, style: { height: '40vh', transform: 'translate(0 , 5vh)', animationName: 'opacityFullToNone', animationDuration: '500ms' } },
          { delay: 500, src: tank_4, style: { height: '40vh', transform: 'translate(calc(-1*(100vw - (0 * 40vh))/2) , 10vh)', animationName: 'opacityNoneToFull', animationDuration: '500ms' } },
          { delay: 3500, src: tank_4, style: { height: '40vh', transform: 'translate(calc(-1*(100vw - (0 * 40vh))/2) , 10vh)', animationName: 'opacityFullToNone', animationDuration: '500ms' } },
          // { delay: 50, style: { animationName: 'animationHassanTanks', animationDuration: '18110ms' } },
        ],
      },
      // textBackgroundColor: '#af8d69',
      nextStepId: 'HASSAN 04',
    },
    {
      id: 'HASSAN 04',
      type: 'sequence',
      sound: HASSAN_FR_SEQ04,
      sound_delay: 50,
      sequence: [
        { type: 'text', text: "Finalement, j'ai couru \u00e0 la maison et j'ai tout racont\u00e9 \u00e0 ma m\u00e8re. ", delay: 2020 },
        { type: 'text', text: "Heureusement, mon oncle a \u00e9galement r\u00e9ussi \u00e0 s'enfuir \u00e0 temps ", delay: 3210 },
        { type: 'text', text: "et est venu \u00e0 la maison o\u00f9 je l'ai trouv\u00e9 en train de pleurer.", delay: 3000 },
        { type: 'text', text: 'Ils ont tir\u00e9 sur son fils, mon cousin.', delay: 2940 },
        { type: 'text', text: 'Je suis furieux. ', delay: 3000 },
        { type: 'text', text: 'Il veut faire un proc\u00e8s et me supplie \nde partager la vid\u00e9o que j\u2019ai fait sur ma page Facebook.', delay: 1040 },
        { type: 'text', text: "M\u00eame si je suis en col\u00e8re, j'h\u00e9site. ", delay: 4010 },
        { type: 'text', text: 'Je trouve cela risqu\u00e9, et je ne veux vraiment pas risquer mon avenir. ', delay: 2010 },
        { type: 'text', text: '', delay: 4980 },
        { type: 'goToNext', delay: 20 },
      ],
      background: {
        src: baseBackgroundImg,
        // style: {}, //transition: 'left linear, top linear, width linear, height linear'
        // animations: [
        //   { delay: 50, style: { animationDuration: '37120ms', animationName: 'scale20' } }, // height: '120%', top: '-10%', width: '120%', left: '-10%'
        // ],
      },

      foreground: {
        src: phoneFill,
        style: { height: '80vh', opacity: 0, marginBottom: 'auto' },
        animations: [
          { delay: 2020, style: { animationName: 'hassanPhoneAnimation1 ', animationDuration: '9150ms' } },
          { delay: 12150, src: phoneHalf, style: { height: '80vh', opacity: 1, marginBottom: 'auto' } },
          { delay: 7070, src: phoneClear, style: { height: '80vh', opacity: 1, marginBottom: 'auto', animationName: 'hassanPhoneAnimation2 ', animationDuration: '70000ms' } },
        ],
      },
      // textBackgroundColor: '#af8d69',
      nextStepId: 'info1',
    },
    {
      id: 'choice1',
      type: 'choice',

      ...base_choice_style,
      contentText:
        'Que <span class="background-underlined medium">ferais-tu</span> à ma place&thinsp;?<br/>Dénoncer cette injustice et <span class="background-underlined large">partager la vi</span>déo sur les réseaux sociaux ou jouer la prudence et <span class="background-underlined very-large">ne rien faire</span>&thinsp;?',
      choices: [
        {
          type: 'button',
          key: 'button-1',
          text: 'Partager la vidéo',
          buttonStyle: choiceButtonStyle,
          action: 'goNext',
          nextStepId: 'HASSAN 05',
          // action: 'showConfirmation',
          // confirmationContent: {
          //   title: '<span class="background-underlined large">Es-tu certain.e&thinsp;?</span>',
          //   buttons: [
          //     {
          //       text: 'Oui, je suis<br/>sûr.e de moi',
          //       buttonStyle: choiceButtonStyle,
          //       action: 'goNext',
          //       nextStepId: 'HASSAN 05',
          //     },
          //     {
          //       text: 'Je reviens<br/>sur ma décision',
          //       buttonStyle: choiceButtonStyle,
          //       action: 'closeConfirmation',
          //     },
          //   ],
          // },
        },
        {
          type: 'button',
          key: 'button-2',
          text: 'Ne pas partager la vidéo',
          buttonStyle: choiceButtonStyle,
          action: 'goNext',
          nextStepId: 'HASSAN 06',
          // action: 'showConfirmation',
          // confirmationContent: {
          //   title: '<span class="background-underlined large">Es-tu certain.e&thinsp;?</span>',
          //   buttons: [
          //     {
          //       text: 'Oui, je suis<br/>sûr.e de moi',
          //       buttonStyle: choiceButtonStyle,
          //       action: 'goNext',
          //       nextStepId: 'HASSAN 06',
          //     },
          //     {
          //       text: 'Je reviens<br/>sur ma décision',
          //       buttonStyle: choiceButtonStyle,
          //       action: 'closeConfirmation',
          //     },
          //   ],
          // },
        },
      ],
    },
    //5
    {
      id: 'HASSAN 05',
      type: 'sequence',
      sound: HASSAN_FR_SEQ05,
      sound_delay: 50,
      sequence: [
        { type: 'text', text: "Ma m\u00e8re est furieuse quand elle apprend ce que j'ai fait.", delay: 1060 },
        { type: 'text', text: 'Peu apr\u00e8s, j\u2019ai re\u00e7u un message priv\u00e9 d\u2019une personne que je ne connais pas&thinsp;:', delay: 2180 },
        { type: 'text', text: '\u00ab Si tu ne pars pas, nous nous chargerons de te faire disparaitre \u00bb. ', delay: 3990 },
        { type: 'text', text: 'Je suis terrifi\u00e9. Partir&thinsp;? Mais o\u00f9&thinsp;? ', delay: 3780 },
        { type: 'text', text: "La Turquie n'est pas loin et je peux y aller facilement.", delay: 2230 },
        { type: 'text', text: 'Je pourrais aussi aller dans le Sud \u00e0 Tartous o\u00f9 vit un mon cousin, Hamid. ', delay: 2910 },
        { type: 'text', text: "C'est assez paisible l\u00e0-bas, et si je fais profil bas, ", delay: 3910 },
        { type: 'text', text: "je pourrais rester en s\u00e9curit\u00e9 jusqu'\u00e0 ce que les choses se calment \u00e0 nouveau ici.", delay: 2960 },
        { type: 'text', text: '', delay: 6040 },
        { type: 'goToNext', delay: 20 },
      ],
      background: {
        src: baseBackgroundImg,
        // style: {}, //transition: 'left linear, top linear, width linear, height linear'
        // animations: [
        //   { delay: 50, style: { animationDuration: '37120ms', animationName: 'scale20' } }, // height: '120%', top: '-10%', width: '120%', left: '-10%'
        // ],
      },

      foreground: {
        src: sequenceShared1,
        style: { height: '80vh', opacity: 0 },
        animations: [
          { delay: 50, style: { animationName: 'opacityNoneToFull', animationDuration: '1690ms' } },
          { delay: 1690, style: { animationName: 'opacityFullToNone', animationDuration: '1390ms' } },
          { delay: 1390, src: sequenceShared2, style: { animationName: 'opacityNoneToFull', animationDuration: '1990ms' } },
          { delay: 1990, src: sequenceShared2, style: { animationName: 'opacityFullToNone', animationDuration: '1990ms' } },
          { delay: 1990, src: sequenceShared3, style: { animationName: 'opacityNoneToFull', animationDuration: '2780ms' } },
          { delay: 3990, src: sequenceShared3, style: { animationName: 'opacityFullToNone', animationDuration: '1780ms' } },
          { delay: 1780, src: sequenceShared4, style: { height: '40vh', animationName: 'animationHassanSent4', animationDuration: '13780ms' } },
          // src: sequenceShared2,
          // { delay: 50, style: { animationName: 'animationHassanSent1', animationDuration: '3690ms' } },
          // { delay: 3690, src: sequenceShared2, style:{ animationName: 'animationHassanSent2', animationDuration: '3990ms' } },
          // { delay: 3990, src: sequenceShared3, style:{ animationName: 'animationHassanSent3', animationDuration: '5780ms' } },
          // { delay: 6080, src: sequenceShared4, style:{height: '40vh', animationName: 'animationHassanSent4', animationDuration: '13780ms' }},
        ],
      },
      // textBackgroundColor: '#af8d69',
      nextStepId: 'info2',
    },
    {
      id: 'choice2',
      type: 'choice',

      ...base_choice_style,
      contentText:
        'J’hésite, qu’est-ce <span class="background-underlined very-large">que tu ferais, to</span>i&thinsp;?<br/>Rest<span class="background-underlined large">erais-tu en Syrie</span> en te cachant chez ton cousin ? Ou <span class="background-underlined large">fuirais-tu</span> immédiatement en Turquie par sécurité ?',
      choices: [
        {
          type: 'button',
          key: 'button-1',
          text: 'Se cacher chez mon cousin à Tartous',
          buttonStyle: choiceButtonStyle,
          action: 'goNext',
          nextStepId: 'HASSAN 08',
          // action: 'showConfirmation',
          // confirmationContent: {
          //   title: '<span class="background-underlined large">Es-tu certain.e&thinsp;?</span>',
          //   buttons: [
          //     {
          //       text: 'Oui, je suis<br/>sûr.e de moi',
          //       buttonStyle: choiceButtonStyle,
          //       action: 'goNext',
          //       nextStepId: 'HASSAN 08',
          //     },
          //     {
          //       text: 'Je reviens<br/>sur ma décision',
          //       buttonStyle: choiceButtonStyle,
          //       action: 'closeConfirmation',
          //     },
          //   ],
          // },
        },
        {
          type: 'button',
          key: 'button-2',
          text: 'Fuir vers la Turquie',
          buttonStyle: choiceButtonStyle,
          action: 'goNext',
          nextStepId: 'mapTurquie',
          // action: 'showConfirmation',
          // confirmationContent: {
          //   title: '<span class="background-underlined large">Es-tu certain.e&thinsp;?</span>',
          //   buttons: [
          //     {
          //       text: 'Oui, je suis<br/>sûr.e de moi',
          //       buttonStyle: choiceButtonStyle,
          //       action: 'goNext',
          //       nextStepId: 'mapTurquie',
          //     },
          //     {
          //       text: 'Je reviens<br/>sur ma décision',
          //       buttonStyle: choiceButtonStyle,
          //       action: 'closeConfirmation',
          //     },
          //   ],
          // },
        },
      ],
    },
    {
      id: 'mapTurquie',
      type: 'map',
      background: baseBackgroundImg,
      mapImage: mapSyrieTurquie,
      mapContainerClass: 'cursor-gray',
      nextStepDelay: 3500,
      nextStepId: 'HASSAN 10',
    },
    {
      id: 'HASSAN 06',
      type: 'sequence',
      sound: HASSAN_FR_SEQ06,
      sound_delay: 50,
      sequence: [
        { type: 'text', text: 'Je d\u00e9cide de ne pas partager la vid\u00e9o et de la supprimer, juste pour \u00eatre s\u00fbr. ', delay: 1170 },
        { type: 'text', text: "Mon oncle \u00e9tait d'abord en col\u00e8re, mais il a fini par comprendre mon choix. ", delay: 3960 },
        { type: 'text', text: 'Son chagrin pour la perte de son fils est \u00e9norme, le mien aussi. ', delay: 4060 },
        { type: 'text', text: "La situation s'aggrave de plus en plus, j'esp\u00e8re seulement que cela passera bient\u00f4t. ", delay: 4850 },
        { type: 'text', text: '', delay: 5190 },
        { type: 'goToNext', delay: 1780 },
      ],
      background: {
        src: baseBackgroundImg,
        // style: {}, //transition: 'left linear, top linear, width linear, height linear'
        // animations: [
        //   { delay: 50, style: { animationDuration: '37120ms', animationName: 'scale20' } }, // height: '120%', top: '-10%', width: '120%', left: '-10%'
        // ],
      },
      foreground: {
        src: sequenceNotShared1,
        style: { height: '80vh', opacity: 0 },
        animations: [
          { delay: 50, style: { animationName: 'opacityNoneToFull', animationDuration: '1000ms' } },
          { delay: 4080, style: { animationName: 'opacityFullToNone', animationDuration: '500ms' } },
          // { delay: 500, src: sequenceNotShared2, style:{ animationName: 'opacityNoneToFull', animationDuration: '1000ms' } },
          // { delay: 9190, style: { animationName: 'opacityFullToNone', animationDuration: '500ms' } },
          { delay: 500, src: sequenceNotShared3, style: { animationName: 'opacityNoneToFull', animationDuration: '1000ms' } },
        ],
      },
      // textBackgroundColor: '#af8d69',
      nextStepId: 'HASSAN 07',
    },
    {
      id: 'HASSAN 07',
      type: 'sequence',
      sound: HASSAN_FR_SEQ07,
      sound_delay: 50,
      sequence: [
        { type: 'text', text: 'La guerre a commenc\u00e9. ', delay: 2070 },
        { type: 'text', text: "L\u00e0 o\u00f9 je vis, c'est plut\u00f4t calme. ", delay: 1950 },
        { type: 'text', text: "Mes parents ont pens\u00e9 qu'\u00e9tudier \u00e0 Damas serait trop risqu\u00e9, \nalors je suis rest\u00e9 \u00e0 Lattaqui\u00e9. ", delay: 2110 },
        {
          type: 'text',
          text: "Comme je ne fais pas d\u2019\u00e9tudes, j\u2019ai re\u00e7u une lettre m\u2019invitant \n\u00e0 me pr\u00e9senter \u00e0 l'arm\u00e9e pour mon service militaire. ",
          delay: 5090,
        },
        { type: 'text', text: 'Mon fr\u00e8re y est depuis 2 ans ', delay: 5910 },
        { type: 'text', text: 'et \u00e7a fait maintenant 6 mois que nous sommes sans nouvelles de lui. ', delay: 1030 },
        { type: 'text', text: "Nous ne savons m\u00eame pas s'il est encore en vie. ", delay: 3020 },
        { type: 'text', text: 'Je ne veux vraiment pas faire l\u2019arm\u00e9e, ', delay: 2910 },
        { type: 'text', text: 'avoir \u00e0 me battre avec des gens qui sont mes amis ou risquer d\u2019\u00eatre tu\u00e9.', delay: 1930 },
        { type: 'text', text: 'La seule autre option est de fuir. ', delay: 5060 },
        { type: 'text', text: 'Cela signifie quitter ma famille, mes amis, renoncer \u00e0 mon avenir.', delay: 2010 },
        { type: 'text', text: 'Sans savoir quand je vais pouvoir revenir.', delay: 4110 },
        { type: 'text', text: "J'ai l'impression de devoir choisir entre la peste et le chol\u00e9ra.", delay: 2880 },
        { type: 'text', text: '', delay: 3990 },
        { type: 'goToNext', delay: 1070 },
      ],
      background: {
        src: hassanBG7,
        style: {}, //transition: 'left linear, top linear, width linear, height linear'
        animations: [
          { delay: 50, style: { animationDuration: '44070ms', animationName: 'scale40' } }, // height: '120%', top: '-10%', width: '120%', left: '-10%'
        ],
      },
      // textBackgroundColor: '#af8d69',
      nextStepId: 'info4',
    },
    //10
    {
      id: 'choice4',
      type: 'choice',

      ...base_choice_style,
      contentText:
        'Quel dilemme! Que ferais-<span class="background-underlined large">tu à ma place</span>&thinsp;?<br/>Rejoindrais-tu <span class="background-underlined very-large">l’armée gouvernementale</span> ou laisserais-tu tout le monde derrière toi pour <span class="background-underlined large">fuir en Turquie</span>&thinsp;?',
      choices: [
        {
          type: 'button',
          key: 'button-1',
          text: 'Quitter la Syrie',
          buttonStyle: choiceButtonStyle,
          action: 'showConfirmation',
          confirmationContent: {
            title: '<span class="background-underlined large">Es-tu certain.e&thinsp;?</span><br/>Ma famille va tellement me manquer',
            buttons: [
              {
                text: 'Oui, je suis<br/>sûr.e de moi',
                buttonStyle: choiceButtonStyle,
                action: 'goNext',
                nextStepId: 'mapTurquie',
              },
              {
                text: 'Je reviens<br/>sur ma décision',
                buttonStyle: choiceButtonStyle,
                action: 'closeConfirmation',
              },
            ],
          },
        },
        {
          type: 'button',
          key: 'button-2',
          text: 'Rejoindre l’armée',
          buttonStyle: choiceButtonStyle,
          action: 'showConfirmation',
          confirmationContent: {
            title: '<span class="background-underlined large">Es-tu certain.e&thinsp;?</span><br/>Je ne veux pas avoir à tuer des innocent·e·s',
            buttons: [
              {
                text: 'Oui, je suis<br/>sûr.e de moi',
                buttonStyle: choiceButtonStyle,
                action: 'goNext',
                nextStepId: 'HASSAN 09',
              },
              {
                text: 'Je reviens<br/>sur ma décision',
                buttonStyle: choiceButtonStyle,
                action: 'closeConfirmation',
              },
            ],
          },
        },
      ],
    },
    {
      id: 'HASSAN 08',
      type: 'sequence',
      sound: HASSAN_FR_SEQ08,
      sound_delay: 50,
      sequence: [
        { type: 'text', text: 'Je suis chez mon cousin Hamid. ', delay: 2180 },
        { type: 'text', text: '\u00c7a m\u2019a fait tr\u00e8s plaisir de le revoir et, malgr\u00e9 les inqui\u00e9tudes, \nje me sentais plut\u00f4t en s\u00e9curit\u00e9. ', delay: 1920 },
        { type: 'text', text: "Mais la guerre a \u00e9clat\u00e9 ici. Je n'aurais jamais pu imaginer \u00e7a. ", delay: 5990 },
        { type: 'text', text: "\u00c9tudier n'est pas une option en ce moment.", delay: 3990 },
        { type: 'text', text: "Et j\u2019ai donc \u00e9t\u00e9 convoqu\u00e9 par l'arm\u00e9e pour le service militaire. ", delay: 2040 },
        { type: 'text', text: 'Mon fr\u00e8re y est depuis 2 ans ', delay: 3080 },
        { type: 'text', text: 'et \u00e7a fait maintenant 6 mois que nous sommes sans nouvelles de lui. ', delay: 1910 },
        { type: 'text', text: "Nous ne savons m\u00eame pas s'il est encore en vie.", delay: 3070 },
        { type: 'text', text: 'Je ne veux vraiment pas faire l\u2019arm\u00e9e, ', delay: 2940 },
        { type: 'text', text: 'avoir \u00e0 me battre avec des gens qui sont mes amis ou risquer d\u2019\u00eatre tu\u00e9. ', delay: 1930 },
        { type: 'text', text: 'Si je ne me pr\u00e9sente pas, je peux \u00eatre arr\u00eat\u00e9 \u00e0 tout moment', delay: 4050 },
        { type: 'text', text: 'et chaque fois que je sortirai dans la rue, je serai terrifi\u00e9.', delay: 2970 },
        { type: 'text', text: 'Pire, je mettrai Hamid, ma tante et mon oncle en danger.', delay: 2960 },
        { type: 'text', text: 'La seule autre option est de fuir la Syrie.', delay: 3150 },
        { type: 'text', text: 'Cela signifie quitter ma famille, mes amis, renoncer \u00e0 mon avenir.', delay: 2830 },
        { type: 'text', text: 'Sans savoir quand je vais pouvoir revenir.', delay: 4150 },
        { type: 'text', text: "J'ai l'impression de devoir choisir entre la peste et le chol\u00e9ra.", delay: 2870 },
        { type: 'text', text: 'Quel dilemme impossible.', delay: 3150 },
        { type: 'text', text: '', delay: 3830 },
        { type: 'goToNext', delay: 3160 },
      ],
      background: {
        src: hassanBG8,
        style: {},
        animations: [{ delay: 50, style: { animationName: 'scale30', animationDuration: '59010ms' } }],
      },
      // textBackgroundColor: '#af8d69',
      nextStepId: 'info3',
    },
    {
      id: 'choice3',
      type: 'choice',

      ...base_choice_style,
      contentText:
        'Quel dilemme! Que ferais-<span class="background-underlined large">tu à ma place</span>&thinsp;?<br/>Rejoindrais-tu <span class="background-underlined very-large">l’armée gouvernementale</span> ou laisserais-tu tout le monde derrière toi pour <span class="background-underlined large">fuir en Turquie</span>&thinsp;?',
      choices: [
        {
          type: 'button',
          key: 'button-1',
          text: 'Quitter la Syrie',
          buttonStyle: choiceButtonStyle,
          action: 'showConfirmation',
          confirmationContent: {
            title: '<span class="background-underlined large">Es-tu certain·e&thinsp;?</span><br/>Ma famille va tellement me manquer',
            buttons: [
              {
                text: 'Oui, je suis<br/>sûr.e de moi',
                buttonStyle: choiceButtonStyle,
                action: 'goNext',
                nextStepId: 'mapTurquie',
              },
              {
                text: 'Je reviens<br/>sur ma décision',
                buttonStyle: choiceButtonStyle,
                action: 'closeConfirmation',
              },
            ],
          },
        },
        {
          type: 'button',
          key: 'button-2',
          text: "Rejoindre l'armée",
          buttonStyle: choiceButtonStyle,
          action: 'showConfirmation',
          confirmationContent: {
            title: '<span class="background-underlined large">Es-tu certain·e&thinsp;?</span><br/>Je ne veux pas avoir à tuer des innocent·e·s',
            buttons: [
              {
                text: 'Oui, je suis<br/>sûr.e de moi',
                buttonStyle: choiceButtonStyle,
                action: 'goNext',
                nextStepId: 'HASSAN 09',
              },
              {
                text: 'Je reviens<br/>sur ma décision',
                buttonStyle: choiceButtonStyle,
                action: 'closeConfirmation',
              },
            ],
          },
        },
      ],
    },
    {
      id: 'HASSAN 09',
      type: 'sequence',
      sound: HASSAN_FR_SEQ09,
      sound_delay: 50,
      sequence: [
        { type: 'text', text: "Je me suis engag\u00e9 dans l'arm\u00e9e gouvernementale. ", delay: 3160 },
        { type: 'text', text: "Ce n'est pas comme \u00e7a que j'imaginais mon avenir. ", delay: 2880 },
        { type: 'text', text: 'Mon sup\u00e9rieur m\u2019a rapidement pris en grippe. ', delay: 2070 },
        { type: 'text', text: 'Il a vite compris que je n\u2019\u00e9tais pas fait pour me battre ', delay: 2060 },
        { type: 'text', text: "et ne peut s'emp\u00eacher de me taquiner et de m'humilier devant les autres. ", delay: 2050 },
        { type: 'text', text: "Mais c'est peut-\u00eatre le moindre de mes soucis. ", delay: 3920 },
        { type: 'text', text: "J'ai constamment peur de devoir partir au combat. ", delay: 2050 },
        { type: 'text', text: 'Dans cette guerre, on ne sait plus tr\u00e8s bien qui sont les ennemis, ', delay: 2930 },
        { type: 'text', text: "j'ai entendu des histoires d'autres soldats qui ont d\u00fb tirer sur des amis. ", delay: 2900 },
        { type: 'text', text: "J'ai l'impression que je ne peux faire confiance \u00e0 personne. ", delay: 4100 },
        { type: 'text', text: "Je n'ai absolument pas le droit de critiquer le pr\u00e9sident \ncar cela pourrait me co\u00fbter la vie. ", delay: 2980 },
        { type: 'text', text: "Et en tant que soldat de l'arm\u00e9e syrienne, je suis aussi d\u00e9test\u00e9.", delay: 4100 },
        { type: 'text', text: 'Mon pays est totalement bris\u00e9.', delay: 3990 },
        { type: 'text', text: 'Je suis aussi totalement bris\u00e9.', delay: 2810 },
        { type: 'text', text: '', delay: 4100 },
        { type: 'goToNext', delay: 1910 },
      ],
      background: {
        src: hassanBG9,
        style: {}, //transition: 'left linear, top linear, width linear, height linear'
        animations: [
          { delay: 50, style: { animationDuration: '46100ms', animationName: 'scale20' } }, // height: '120%', top: '-10%', width: '120%', left: '-10%'
        ],
      },
      // textBackgroundColor: '#af8d69',
      nextStepId: 'epilogue_armee',
    },
    {
      id: 'epilogue_armee',

      ...base_epilogue,

      sound: HASSAN_FR_EPILOG1,
      sound_delay: epilogeAnimationTiming + epilogeSoundAdditionalDelay,
      sequence: [
        {
          delay: epilogeAnimationTiming,
          text: "Un jour, nous devons nous battre à Homs, où de violents combats opposent depuis longtemps les groupes rebelles et l'armée gouvernementale. Je fais profil bas et j'essaie de ne pas tirer. J'ai un mauvais pressentiment. Soudain, j'entends un bruit terrible, puis une détonation. Je tombe par terre, je n'entends plus rien. Tout. Devient. Noir",
          textStyle: { left: '45vw' },
        },
      ],
      nextStepId: 'other_choices',
    },
    //15
    {
      id: 'other_choices',
      type: 'choice',

      ...base_choice_style,

      fixedImageBackground: baseBackgroundImg,

      fixedImageBackgroundStyle: {
        backgroundSize: '100% 100%',
        backgroundPosition: 'center',
        zIndex: 0,
      },

      contentStyle: {
        width: '100%',
        maxWidth: '500px',
        marginLeft: 'auto',
        marginRight: 'auto',
        color: 'white',
        zIndex: 100,
      },
      contentTextStyle: {
        textTransform: 'none',
        textAlign: 'center',
      },
      contentText: 'Voudrais-tu savoir ce qui se serait passé si tu avais fait <span class="background-underlined large white">d’autres choix&thinsp;?</span>',

      choices: [
        {
          type: 'button',
          key: 'button-1',
          text: 'Oui, je reviens au début du parcours',
          buttonStyle: otherChoiceButtonStyle,
          action: 'goNext',
          nextStepId: 'HASSAN 01',
        },
        {
          type: 'button',
          key: 'button-2',
          text: 'Non',
          buttonStyle: otherChoiceButtonStyle,
          action: 'goNext',
          nextStepId: '-1',
        },
      ],
    },
    {
      id: 'HASSAN 10',
      type: 'sequence',
      sound: HASSAN_FR_SEQ10,
      sound_delay: 50,
      sequence: [
        { type: 'text', text: "Quitter la Syrie m'a arrach\u00e9 le c\u0153ur. ", delay: 3040 },
        { type: 'text', text: "C'est la chose la plus difficile que j'aie jamais eu \u00e0 faire. ", delay: 1990 },
        { type: 'text', text: "Quitter son pays, s'\u00e9loigner de sa famille, de ses amis ", delay: 3050 },
        { type: 'text', text: "et de tout ce que l'on conna\u00eet, sans certitude de revenir un jour.", delay: 2970 },
        { type: 'text', text: 'Je ne le souhaite \u00e0 personne. ', delay: 3950 },
        { type: 'text', text: 'Je suis maintenant \u00e0 Mersin, une ville portuaire de Turquie \no\u00f9 vit le meilleur ami de mon p\u00e8re. ', delay: 2020 },
        { type: 'text', text: 'Pour arriver ici, j\u2019ai pris un bus, puis une voiture.', delay: 4990 },
        { type: 'text', text: "J'\u00e9tais mort de peur quand on a pass\u00e9 les contr\u00f4les \u00e0 la fronti\u00e8re, \nmais on nous a laiss\u00e9 passer.", delay: 2220 },
        { type: 'text', text: "Je me demande combien d'argent mon p\u00e8re a d\u00fb donner pour \u00e7a.", delay: 5810 },
        { type: 'text', text: 'Il y a beaucoup de r\u00e9fugi\u00e9s syriens ici. ', delay: 2200 },
        { type: 'text', text: "Je travaille ici et l\u00e0 pour gagner un peu d'argent. ", delay: 2870 },
        { type: 'text', text: "J'ai fait la connaissance d'un gar\u00e7on de ma r\u00e9gion, Salim.", delay: 3030 },
        { type: 'text', text: 'J\u2019ai la sensation qu\u2019il est un peu comme mon \u00e2me s\u0153ur. ', delay: 2990 },
        { type: 'text', text: 'Nous sommes constamment ensemble', delay: 2950 },
        { type: 'text', text: ' et nous nous entraidons quand nous le pouvons.', delay: 1020 },
        { type: 'text', text: '', delay: 4030 },
        { type: 'goToNext', delay: 1880 },
      ],
      background: {
        src: hassanBG10,
        style: {}, //transition: 'left linear, top linear, width linear, height linear'
        animations: [
          { delay: 50, style: { animationDuration: '49130ms', animationName: 'scaleDown20' } }, // height: '120%', top: '-10%', width: '120%', left: '-10%'
        ],
      },
      // textBackgroundColor: '#af8d69',
      nextStepId: 'HASSAN 11',
    },
    {
      id: 'HASSAN 11',
      type: 'sequence',
      sound: HASSAN_FR_SEQ11,
      sound_delay: 50,
      sequence: [
        { type: 'text', text: 'Un jour, nous parlons de notre avenir. ', delay: 4000 },
        { type: 'text', text: 'Nous avons tous les deux une vision sombre de la situation.', delay: 2200 },
        { type: 'text', text: 'Salim a aussi des r\u00eaves. ', delay: 3040 },
        { type: 'text', text: "Il a toujours \u00e9t\u00e9 un gamer et souhaite devenir un professionnel de l'informatique.", delay: 1870 },
        { type: 'text', text: 'Nous savons tous deux qu\u2019on a aucune chance de r\u00e9aliser nos r\u00eaves en Turquie. ', delay: 5000 },
        { type: 'text', text: 'Salim parle de l\u2019Europe, et de la Belgique o\u00f9 vit son fr\u00e8re. ', delay: 3980 },
        { type: 'text', text: 'Il me propose d\u2019aller avec lui. ', delay: 3100 },
        { type: 'text', text: "L'id\u00e9e de rester ici seul n'est pas tr\u00e8s attrayante ", delay: 2050 },
        { type: 'text', text: 'mais le voyage en Europe est tr\u00e8s dangereux et coute tr\u00e8s cher. ', delay: 2780 },
        { type: 'text', text: "Je ne veux pas demander de l'argent \u00e0 mes parents. ", delay: 3060 },
        { type: 'text', text: 'Leur parler de mon projet de me rendre en Europe les inqui\u00e9terait trop.', delay: 2000 },
        { type: 'text', text: "Et suivre Salim, me co\u00fbterait tout l'argent que j'ai.", delay: 3150 },
        { type: 'text', text: '', delay: 3430 },
        { type: 'goToNext', delay: 1510 },
      ],
      background: {
        src: hassanBG11,
        style: {},
        animations: [{ delay: 50, style: { animationDuration: '39160ms', animationName: 'scale20' } }],
      },
      // textBackgroundColor: '#af8d69',
      nextStepId: 'infoEurope',
    },
    {
      id: 'choiceEurope',
      type: 'choice',

      ...base_choice_style,
      contentText:
        'Je ne sais vraiment pas ce que je dois faire. Qu’est-ce que tu ferais si tu étais dan<span class="background-underlined medium">s mes chaussur</span>es&thinsp;?<br/>Acompagnerais-tu Sali<span class="background-underlined large">m en Europe</span> en risquant ta vie ? Ou resterais-tu s<span class="background-underlined large">eul·e en Turquie</span> en espérant pouvoir y avoir tout de même une vie décente&thinsp;?',
      choices: [
        {
          type: 'button',
          key: 'button-1',
          text: 'Rester en Turquie',
          buttonStyle: choiceButtonStyle,
          action: 'goNext',
          nextStepId: 'mapIncoherence1',
          // nextStepId: 'HASSAN 14',
          // action: 'showConfirmation',
          // confirmationContent: {
          //   title: '<span class="background-underlined large">Es-tu certain.e&thinsp;?</span>',
          //   buttons: [
          //     {
          //       text: 'Oui, je suis<br/>sûr.e de moi',
          //       buttonStyle: choiceButtonStyle,
          //       action: 'goNext',
          //       nextStepId: 'HASSAN 14',
          //     },
          //     {
          //       text: 'Je reviens<br/>sur ma décision',
          //       buttonStyle: choiceButtonStyle,
          //       action: 'closeConfirmation',
          //     },
          //   ],
          // },
        },

        {
          type: 'button',
          key: 'button-2',
          text: 'Me joindre à Salim',
          buttonStyle: choiceButtonStyle,
          action: 'goNext',
          nextStepId: 'mapEurope',
          // action: 'showConfirmation',
          // confirmationContent: {
          //   title: '<span class="background-underlined large">Es-tu certain.e&thinsp;?</span>',
          //   buttons: [
          //     {
          //       text: 'Oui, je suis<br/>sûr.e de moi',
          //       buttonStyle: choiceButtonStyle,
          //       action: 'goNext',
          //       nextStepId: 'mapEurope',
          //     },
          //     {
          //       text: 'Je reviens<br/>sur ma décision',
          //       buttonStyle: choiceButtonStyle,
          //       action: 'closeConfirmation',
          //     },
          //   ],
          // },
        },
      ],
    },
    {
      id: 'mapEurope',
      type: 'map',
      background: baseBackgroundImg,
      mapImage: mapTurquieEurope,
      mapContainerClass: 'cursor-gray',
      nextStepDelay: 3500,
      nextStepId: 'HASSAN 12',
    },
    //20
    {
      id: 'HASSAN 12',
      type: 'sequence',
      sound: HASSAN_FR_SEQ12,
      sound_delay: 50,
      sequence: [
        { type: 'text', text: "Sans Salim, je n'aurais jamais os\u00e9 \nmais nous sommes devenus si proches ces derniers mois ", delay: 5110 },
        { type: 'text', text: "qu'il est presque comme un fr\u00e8re pour moi. ", delay: 3120 },
        { type: 'text', text: "Avec le peu d'argent que nous avions, nous avons trouv\u00e9 un passeur", delay: 2900 },
        { type: 'text', text: 'qui nous a aid\u00e9s \u00e0 passer en Gr\u00e8ce et ensuite plus loin en Europe.', delay: 2980 },
        { type: 'text', text: 'Il a \u00e9t\u00e9 difficile de d\u00e9terminer le meilleur itin\u00e9raire ', delay: 3930 },
        { type: 'text', text: "car de plus en plus de fronti\u00e8res vers l'Europe sont verrouill\u00e9es \npour arr\u00eater les gens comme nous. ", delay: 2100 },
        { type: 'text', text: 'Nous avons navigu\u00e9 dans un bateau sur la rivi\u00e8re sauvage Evros \npour aller plus loin en Gr\u00e8ce. ', delay: 4940 },
        { type: 'text', text: 'Nous sommes au moins 50 sur un bateau qui, \nje pense, est pr\u00e9vu pour 20 personnes. ', delay: 4920 },
        { type: 'text', text: 'Il y a beaucoup de vent et il pleut si fort que nous ne pouvons presque rien voir.  ', delay: 4100 },
        { type: 'text', text: "Nous n'arrivons pas \u00e0 ma\u00eetriser notre bateau. ", delay: 4020 },
        { type: 'text', text: "Je vois que Salim s'agite", delay: 2060 },
        { type: 'text', text: "Il est en panique. Je lui crie de rester calme mais il ne m'entend pas.", delay: 1050 },
        { type: 'text', text: 'Je crie son nom mais je ne le vois plus.', delay: 3960 },
        { type: 'text', text: "Je r\u00e9alise maintenant qu'il ne porte pas de gilet de sauvetage.", delay: 3850 },
        { type: 'text', text: '', delay: 3030 },
        { type: 'goToNext', delay: 1000 },
      ],
      background: {
        src: hassanBG12,
        style: {},
        animations: [{ delay: 50, style: { animationDuration: '37120ms', animationName: 'scaleDown20' } }],
      },
      backgroundEffect: {
        style: { opacity: 0, backgroundColor: 'black' }, //transition: 'opacity linear'
        animations: [{ delay: 30000, style: { animationName: 'opacityNoneToFull', animationDuration: '20000ms' } }], //opacity: 1
      },
      // textBackgroundColor: '#af8d69',
      nextStepId: 'HASSAN 13',
    },
    {
      id: 'HASSAN 13',
      type: 'sequence',
      sound: HASSAN_FR_SEQ13,
      sound_delay: 50,
      sequence: [
        { type: 'text', text: 'Je suis de retour en Turquie. ', delay: 4210 },
        { type: 'text', text: 'Sans Salim, sans argent, sans perspectives. ', delay: 1910 },
        { type: 'text', text: "Salim s'est probablement noy\u00e9.", delay: 3120 },
        { type: 'text', text: 'Je me souviens du froid que j\u2019ai ressenti \nquand je me suis r\u00e9veill\u00e9 sur la rive du fleuve. ', delay: 2790 },
        { type: 'text', text: "J'ai entendu des cris et des aboiements de chiens \net j'ai senti des gens me donner des coups de pied.", delay: 4020 },
        { type: 'text', text: "Avec d'autres personnes qui \u00e9taient sur mon bateau, \nnous avons \u00e9t\u00e9 expuls\u00e9s de Gr\u00e8ce.", delay: 5170 },
        { type: 'text', text: 'Juste comme \u00e7a. ', delay: 3900 },
        { type: 'text', text: 'Comme si nous \u00e9tions des ordures. ', delay: 1020 },
        { type: 'text', text: 'Tout \u00e7a pour rien. ', delay: 2030 },
        { type: 'text', text: 'Mon meilleur ami a perdu la vie pour rien.', delay: 1920 },
        { type: 'text', text: '', delay: 6000 },
        { type: 'goToNext', delay: 3050 },
      ],
      background: {
        src: hassanBG13,
        style: {}, //transition: 'left linear, top linear, width linear, height linear'
        animations: [
          { delay: 50, style: { animationDuration: '36090ms', animationName: 'scale20' } }, // height: '120%', top: '-10%', width: '120%', left: '-10%'
        ],
      },
      // textBackgroundColor: '#af8d69',
      nextStepId: 'choiceEuropeReessayer',
    },
    {
      id: 'choiceEuropeReessayer',
      type: 'choice',

      ...base_choice_style,
      contentText:
        'Et que dois-je faire maintenant?<br/>Tenterais-tu une nouvelle trav<span class="background-underlined very-large">ersée vers l’Europ</span>e ou resterais-tu en <span class="background-underlined medium">Turquie</span>&thinsp;?',

      choices: [
        {
          type: 'button',
          key: 'button-1',
          text: 'Faire une nouvelle tentative',
          buttonStyle: choiceButtonStyle,
          action: 'fakeChoice',
          actionText: "Je suis brisé, je ne peux plus.<br/>J'ai besoin de repos. En plus je suis fauché",
          actionTextStyle: { backgroundImage: `url(${blockBlancFakeChoiceSmall})`, maxHeight: '60vh', width: '40vw', maxWidth: '400px' },
        },
        {
          type: 'button',
          key: 'button-2',
          text: 'Rester en Turquie',
          buttonStyle: choiceButtonStyle,
          action: 'goNext',
          nextStepId: 'HASSAN 14',
          // action: 'showConfirmation',
          // confirmationContent: {
          //   title: '<span class="background-underlined large">Es-tu certain.e&thinsp;?</span>',
          //   buttons: [
          //     {
          //       text: 'Oui, je suis<br/>sûr.e de moi',
          //       buttonStyle: choiceButtonStyle,
          //       action: 'goNext',
          //       nextStepId: 'HASSAN 14',
          //     },
          //     {
          //       text: 'Je reviens<br/>sur ma décision',
          //       buttonStyle: choiceButtonStyle,
          //       action: 'closeConfirmation',
          //     },
          //   ],
          // },
        },
      ],
    },
    {
      id: 'HASSAN 14',
      type: 'sequence',
      sound: HASSAN_FR_SEQ14,
      sound_delay: 50,
      sequence: [
        { type: 'text', text: "Je finis par trouver un emploi dans une usine de textile pr\u00e8s d'Istanbul. ", delay: 4200 },
        { type: 'text', text: 'Je travaille 60 heures par semaine, mais mon salaire est si bas', delay: 4830 },
        { type: 'text', text: 'que je dois quand m\u00eame aller \u00e0 la mosqu\u00e9e \npour des colis alimentaires de temps en temps.', delay: 2170 },
        { type: 'text', text: 'Je survis. ', delay: 4010 },
        { type: 'text', text: "C'est mieux que la guerre mais on peut difficilement appeler \u00e7a une vie. ", delay: 1890 },
        { type: 'text', text: 'Je vis dans une chambre avec 10 autres Syriens.', delay: 3010 },
        { type: 'text', text: "La nuit, j'ai du mal \u00e0 dormir car je n'arrive pas \u00e0 arr\u00eater de penser. ", delay: 2980 },
        { type: 'text', text: "Les images de ce qui s'est pass\u00e9 d\u00e9filent constamment dans ma t\u00eate. ", delay: 3930 },
        { type: 'text', text: 'La culpabilit\u00e9 aussi. Ai-je fait les bons choix&thinsp;? ', delay: 3110 },
        { type: 'text', text: 'Je suis tr\u00e8s inquiet pour mes parents et ma s\u0153ur. ', delay: 3870 },
        { type: 'text', text: 'Ils vivent toujours en Syrie. ', delay: 2090 },
        { type: 'text', text: "Nous avons souvent des contacts mais d\u00e8s qu'ils ne r\u00e9pondent pas, \nje crains imm\u00e9diatement le pire. ", delay: 1940 },
        { type: 'text', text: "Pendant ce temps, j'ai re\u00e7u la triste nouvelle que mon oncle est mort en Syrie. ", delay: 4200 },
        { type: 'text', text: "Mon p\u00e8re veut que je prenne une petite partie de l'h\u00e9ritage. ", delay: 4900 },
        { type: 'text', text: 'Avec cet argent, je pourrais am\u00e9liorer ma vie en Turquie', delay: 3010 },
        { type: 'text', text: 'ou faire une deuxi\u00e8me tentative pour me rendre en Europe, via les Iles Grecques. ', delay: 3950 },
        { type: 'text', text: '', delay: 3980 },
        { type: 'goToNext', delay: 3191 },
      ],
      background: {
        src: hassanBG14,
        style: {},
        animations: [{ delay: 50, style: { animationDuration: '54090ms', animationName: 'scale20' } }],
      },
      // textBackgroundColor: '#af8d69',
      nextStepId: 'infoResterFinalementTurquie',
    },
    {
      id: 'choiceResterFinalementTurquie',
      type: 'choice',

      ...base_choice_style,
      contentText:
        'Je ne sais plus ce que je dois faire. Que ferais-tu <span class="background-underlined very-large">si tu étais moi</span>&thinsp;? Rest<span class="background-underlined very-large">erais-tu en Turquie</span> et essaierais-tu d’être heureux·se ici? Ou essaierais-tu quand même d’all<span class="background-underlined medium">er en Euro</span>pe?',
      choices: [
        {
          type: 'button',
          key: 'button-1',
          text: 'Essayer d’aller en Europe via les îles grecques',
          buttonStyle: choiceButtonStyle,
          action: 'goNext',
          nextStepId: 'HASSAN 15',
          // action: 'showConfirmation',
          // confirmationContent: {
          //   title: '<span class="background-underlined large">Es-tu certain.e&thinsp;?</span>',
          //   buttons: [
          //     {
          //       text: 'Oui, je suis<br/>sûr.e de moi',
          //       buttonStyle: choiceButtonStyle,
          //       action: 'goNext',
          //       nextStepId: 'HASSAN 15',
          //     },
          //     {
          //       text: 'Je reviens<br/>sur ma décision',
          //       buttonStyle: choiceButtonStyle,
          //       action: 'closeConfirmation',
          //     },
          //   ],
          // },
        },
        {
          type: 'button',
          key: 'button-2',
          text: 'Reconstruire sa vie en Turquie',
          buttonStyle: choiceButtonStyle,
          action: 'goNext',
          nextStepId: 'epilogeEnTurqie',
          // action: 'showConfirmation',
          // confirmationContent: {
          //   title: '<span class="background-underlined large">Es-tu certain.e&thinsp;?</span>',
          //   buttons: [
          //     {
          //       text: 'Oui, je suis<br/>sûr.e de moi',
          //       buttonStyle: choiceButtonStyle,
          //       action: 'goNext',
          //       nextStepId: 'epilogeEnTurqie',
          //     },
          //     {
          //       text: 'Je reviens<br/>sur ma décision',
          //       buttonStyle: choiceButtonStyle,
          //       action: 'closeConfirmation',
          //     },
          //   ],
          // },
        },
      ],
    },
    //25
    {
      id: 'epilogeEnTurqie',

      ...base_epilogue,

      sound: HASSAN_FR_EPILOG2,
      sound_delay: epilogeAnimationTiming + epilogeSoundAdditionalDelay,
      sequence: [
        {
          delay: epilogeAnimationTiming,
          title: 'Voici à quoi ressemble ma vie en Turquie',
          text: "J'ai abandonné mon rêve de faire des études de biologie, mais au moins, je vis maintenant dans un studio assez grand. J’ai trouvé un travail qui paie un peu mieux et parfois je fais du bénévolat dans une ONG en tant que traducteur. Je parle un peu le turc maintenant. La vie n'est pas géniale mais au moins je suis toujours en vie. Ce qui n’est plus le cas de beaucoup de mes amis.",
          textStyle: { left: '45vw' },
        },
      ],
      nextStepId: 'other_choices',
    },
    {
      id: 'HASSAN 15',
      type: 'sequence',
      sound: HASSAN_FR_SEQ15,
      sound_delay: 50,
      sequence: [
        { type: 'text', text: 'Je d\u00e9cide de r\u00e9essayer. ', delay: 6080 },
        { type: 'text', text: 'Cette fois, j\u2018ai inform\u00e9 mes parents. ', delay: 1990 },
        { type: 'text', text: "S\u2019il m\u2019arrive quelque chose, je ne veux pas qu'on croie que j'ai disparu.", delay: 1950 },
        { type: 'text', text: "Mon p\u00e8re me met en garde contre l'\u00eele grecque de Lesbos.", delay: 3140 },
        { type: 'text', text: "Un de ses amis a atterri l\u00e0-bas et n'en est jamais reparti. ", delay: 2980 },
        { type: 'text', text: "Apr\u00e8s deux ans sans aucune chance d'\u00eatre reconnu comme r\u00e9fugi\u00e9,", delay: 3040 },
        { type: 'text', text: "il est devenu fou, a saut\u00e9 dans la mer et s'est noy\u00e9.", delay: 3010 },
        { type: 'text', text: "Il m'exhorte \u00e0 ne pas rester sur l'\u00eele ", delay: 3870 },
        { type: 'text', text: 'mais \u00e0 me rendre en Gr\u00e8ce d\u00e8s que possible, ', delay: 1120 },
        {
          type: 'text',
          text: "puis en Mac\u00e9doine et en Serbie o\u00f9 il conna\u00eet quelqu'un \nqui peut m'aider \u00e0 me rendre en Belgique o\u00f9 vit le fr\u00e8re de Salim.",
          delay: 2860,
        },
        { type: 'text', text: 'Esp\u00e9rons-le&thinsp;!', delay: 6130 },
        { type: 'text', text: '', delay: 1340 },
        { type: 'goToNext', delay: 1010 },
      ],
      background: {
        src: hassanBG15,
        style: {},
        animations: [{ delay: 50, style: { animationDuration: '37110ms', animationName: 'scale20' } }],
      },
      // textBackgroundColor: '#af8d69',
      nextStepId: 'HASSAN 16',
    },
    {
      id: 'HASSAN 16',
      type: 'sequence',
      sound: HASSAN_FR_SEQ16,
      sound_delay: 50,
      sequence: [
        { type: 'text', text: "Je l'ai fait&thinsp;! ", delay: 6080 },
        { type: 'text', text: 'Quand je suis enfin arriv\u00e9 \u00e0 Bruxelles', delay: 1060 },
        { type: 'text', text: 'j\u2019ai eu l\u2019impression que 100kg tombaient de mes \u00e9paules.', delay: 1930 },
        { type: 'text', text: "L'entretien avec le Commissariat G\u00e9n\u00e9ral aux R\u00e9fugi\u00e9s et aux Apatrides a \u00e9t\u00e9 difficile.", delay: 2970 },
        { type: 'text', text: "J'ai d\u00fb raconter mon histoire 10 fois, dans les moindres d\u00e9tails.", delay: 4190 },
        { type: 'text', text: "Je comprends qu'ils veuillent v\u00e9rifier si j'ai bien droit \u00e0 l'asile,", delay: 4800 },
        { type: 'text', text: "mais \u00e0 cause de toutes les questions, j'ai eu l'impression \nde revivre ce cauchemar encore et encore.", delay: 2210 },
        { type: 'text', text: "Cela fait maintenant 6 mois que j'attends une r\u00e9ponse.", delay: 4920 },
        { type: 'text', text: '', delay: 3080 },
        { type: 'goToNext', delay: 870 },
      ],
      background: {
        src: hassanBG16,
        style: {}, //transition: 'left linear, top linear, width linear, height linear'
        animations: [
          { delay: 50, style: { animationDuration: '31240ms', animationName: 'scale20' } }, // height: '120%', top: '-10%', width: '120%', left: '-10%'
        ],
      },
      // textBackgroundColor: '#af8d69',
      nextStepId: 'HASSAN 17',
    },
    {
      id: 'HASSAN 17',
      type: 'sequence',
      sound: HASSAN_FR_SEQ17,
      sound_delay: 50,
      sequence: [
        { type: 'text', text: 'C\u2019est difficile, vraiment. ', delay: 5090 },
        { type: 'text', text: "Il n'y a rien d'autre que je puisse faire \u00e0 part attendre. ", delay: 1980 },
        { type: 'text', text: 'Pourquoi cela prend-il autant de temps&thinsp;? ', delay: 2970 },
        { type: 'text', text: "J'ai l'impression de perdre pied. ", delay: 2020 },
        { type: 'text', text: "J'essaie de garder le moral, mais ma famille me manque tellement. ", delay: 2010 },
        { type: 'text', text: 'Je sais que \u00e7a semble \u00e9trange mais je veux vraiment retourner en Syrie.', delay: 3070 },
        { type: 'text', text: 'Retrouver ma famille, mon pays.', delay: 3070 },
        { type: 'text', text: 'La guerre est presque termin\u00e9e selon certains, ', delay: 2840 },
        { type: 'text', text: 'et gr\u00e2ce \u00e0 une proc\u00e9dure appel\u00e9e \u00ab retour volontaire \u00bb, je pourrais rentrer. ', delay: 2140 },
        { type: 'text', text: 'Peut-\u00eatre que je devrais juste faire \u00e7a&thinsp;?', delay: 4050 },
        { type: 'text', text: '', delay: 1920 },
        { type: 'goToNext', delay: 1010 },
      ],
      background: {
        src: baseBackgroundImg,
        // style: {}, //transition: 'left linear, top linear, width linear, height linear'
        // animations: [
        //   { delay: 50, style: { animationDuration: '37120ms', animationName: 'scale20' } }, // height: '120%', top: '-10%', width: '120%', left: '-10%'
        // ],
      },
      foreground: {
        src: famille,
        style: { height: '50vh', opacity: 0 },
        animations: [
          { delay: 8050, style: { animationName: 'opacityNoneTo80', animationDuration: '4090ms' } },
          { delay: 4090, style: { animationName: 'opacity80ToFull', animationDuration: '2000ms' } },
          { delay: 2090, style: { animationName: 'animationHassanFamille', animationDuration: '15000ms', animationTimingFunction: 'ease-in' } },

          // animationHassanFamille
        ],
      },
      // textBackgroundColor: '#af8d69',
      nextStepId: 'info_retour_volontaire',
    },
    {
      id: 'choice_retour_volontaire',
      type: 'choice',

      ...base_choice_style,
      contentText:
        'Je ne sais vraiment plus quoi faire. Que ferais-tu à ma place ?<br/>Continuerais-tu à patienter même si tu as le sentiment <span class="background-underlined large">de devenir fou</span> et que ta famille te manque terriblement ? Ou essaierais-tu de retou<span class="background-underlined large">rner en Syrie</span>&thinsp;?',
      choices: [
        {
          type: 'button',
          key: 'button-1',
          text: 'Attendre',
          buttonStyle: choiceButtonStyle,
          action: 'goNext',
          nextStepId: 'HASSAN 18',
          // action: 'showConfirmation',
          // confirmationContent: {
          //   title: '<span class="background-underlined large">Es-tu certain.e&thinsp;?</span>',
          //   buttons: [
          //     {
          //       text: 'Oui, je suis<br/>sûr.e de moi',
          //       buttonStyle: choiceButtonStyle,
          //       action: 'goNext',
          //       nextStepId: 'HASSAN 18',
          //     },
          //     {
          //       text: 'Je reviens<br/>sur ma décision',
          //       buttonStyle: choiceButtonStyle,
          //       action: 'closeConfirmation',
          //     },
          //   ],
          // },
        },
        {
          type: 'button',
          key: 'button-2',
          text: 'Retourner en Syrie',
          buttonStyle: choiceButtonStyle,
          action: 'fakeChoice',
          actionText:
            "Lorsque je parle à ma mère de mon projet de retour, elle me demande si j'ai perdu la tête. Elle me dit que la situation y est encore tout à fait intenable. On y craint pour sa vie et il n'y a pas d'avenir pour moi là-bas. Je serais probablement immédiatement arrêté pour avoir manqué à mon devoir militaire. Elle a bien sûr raison. Je reprends vite mes esprits, retourner serait totalement absurde. Je dois à ma famille de mener ma vie au mieux ici. Je le dois à Salim. Sa mort ne doit pas être vaine.",
          actionTextStyle: { backgroundImage: `url(${blockBlancFakeChoiceLarge})`, maxHeight: '60vh', width: '40vw', maxWidth: '600px' },
        },
      ],
    },
    //30
    {
      id: 'HASSAN 18',
      type: 'sequence',
      sound: HASSAN_FR_SEQ18,
      sound_delay: 50,
      sequence: [
        { type: 'text', text: 'J\u2019ai enfin re\u00e7u la lettre lib\u00e9ratrice. ', delay: 2060 },
        { type: 'text', text: 'Je suis reconnu comme r\u00e9fugi\u00e9 et je peux rester. ', delay: 2940 },
        { type: 'text', text: "Cependant, un nouveau probl\u00e8me s'est rapidement pos\u00e9. ", delay: 2210 },
        { type: 'text', text: "Je n'ai que 2 mois pour trouver un endroit o\u00f9 vivre. ", delay: 3800 },
        { type: 'text', text: 'Sinon, je finirai dans la rue. ', delay: 2160 },
        { type: 'text', text: "C'est tellement \u00e9prouvant pour les nerfs. ", delay: 2840 },
        { type: 'text', text: "C'est tr\u00e8s difficile parce que les propri\u00e9taires veulent souvent \nque vous ayez un emploi permanent, ", delay: 2090 },
        { type: 'text', text: 'mais comme je parle \u00e0 peine le fran\u00e7ais, trouver un emploi est presque impossible.', delay: 4920 },
        { type: 'text', text: "C'est un cercle vicieux.", delay: 3070 },
        { type: 'text', text: '', delay: 1080 },
        { type: 'goToNext', delay: 10 },
      ],
      background: {
        src: hassanBG18,
        // style: {}, //transition: 'left linear, top linear, width linear, height linear'
        // animations: [
        //   { delay: 50, style: { animationDuration: '37120ms', animationName: 'scale20' } }, // height: '120%', top: '-10%', width: '120%', left: '-10%'
        // ],
      },
      // textBackgroundColor: '#af8d69',
      nextStepId: 'HASSAN 19',
    },
    {
      id: 'HASSAN 19',
      type: 'sequence',
      sound: HASSAN_FR_SEQ19,
      sound_delay: 50,
      sequence: [
        { type: 'text', text: 'J\u2019ai visit\u00e9 un petit studio \u00e0 Louvain. ', delay: 4050 },
        { type: 'text', text: 'A peine la porte ouverte, j\u2019ai l\u2019estomac qui s\u2019est retourn\u00e9.', delay: 2120 },
        { type: 'text', text: 'Une petite pi\u00e8ce sans fen\u00eatre qui puait.', delay: 2970 },
        { type: 'text', text: "J'ai m\u00eame vu des crottes de souris sur le sol.", delay: 3050 },
        { type: 'text', text: 'Il y a une salle de bain dans le couloir que je dois partager avec 5 autres personnes. ', delay: 2860 },
        { type: 'text', text: 'Si je ne le prends pas, je serai sans abri.', delay: 4000 },
        { type: 'text', text: "C'est la premi\u00e8re fois, apr\u00e8s des mois de recherche, \nqu'un propri\u00e9taire accepte de me louer un logement. ", delay: 2170 },
        { type: 'text', text: '', delay: 6870 },
        { type: 'goToNext', delay: 930 },
      ],
      background: {
        src: hassanBG19,
        style: { objectPosition: 'center 10%' },
        animations: [{ delay: 50, style: { animationDuration: '28090ms', animationName: 'scale20' } }],
      },
      // textBackgroundColor: '#af8d69',
      nextStepId: 'info_appartement',
    },
    {
      id: 'choice_appartement',
      type: 'choice',

      ...base_choice_style,
      contentText:
        'Que dois-je décider&thinsp;? Que ferais-tu, toi&thinsp;? <br/>Signer<span class="background-underlined large">ais-tu le contrat</span> pour être sûr·e de ne pas devoir dormir dehors ? Ou cherc<span class="background-underlined very-large">herais-tu encore un pe</span>u en espérant trouver quelque-chose de mieux ?',
      choices: [
        {
          type: 'button',
          key: 'button-1',
          text: 'Signer le contrat',
          buttonStyle: choiceButtonStyle,
          action: 'showConfirmation',
          confirmationContent: {
            title: '<span class="background-underlined large">Es-tu certain.e&thinsp;?</span><br/>Quand je pense que je vais devoir vivre ici un an, j\'en ai presque l\'estomac qui se retourne.',
            buttons: [
              {
                text: 'Oui, je suis<br/>sûr.e de moi',
                buttonStyle: choiceButtonStyle,
                action: 'goNext',
                nextStepId: 'HASSAN 20',
              },
              {
                text: 'Je reviens<br/>sur ma décision',
                buttonStyle: choiceButtonStyle,
                action: 'closeConfirmation',
              },
            ],
          },
        },
        {
          type: 'button',
          key: 'button-2',
          text: 'Chercher encore un peu',
          buttonStyle: choiceButtonStyle,
          action: 'showConfirmation',
          confirmationContent: {
            title: '<span class="background-underlined large">Es-tu certain.e&thinsp;?</span><br/>Et si je ne trouve rien ? Je n\'ai vraiment pas envie de me retrouver à la rue !',
            buttons: [
              {
                text: 'Oui, je suis<br/>sûr.e de moi',
                buttonStyle: choiceButtonStyle,
                action: 'goNext',
                nextStepId: 'HASSAN 21',
              },
              {
                text: 'Je reviens<br/>sur ma décision',
                buttonStyle: choiceButtonStyle,
                action: 'closeConfirmation',
              },
            ],
          },
        },
      ],
    },
    {
      id: 'HASSAN 20',
      type: 'sequence',
      sound: HASSAN_FR_SEQ20,
      sound_delay: 50,
      sequence: [
        { type: 'text', text: 'Je d\u00e9cide quand m\u00eame de signer le contrat. ', delay: 4090 },
        { type: 'text', text: 'Je ne veux pas courir le risque de devoir dormir dans la rue.', delay: 2100 },
        { type: 'text', text: "J'essaie de ranger un peu ma chambre mais c'est difficile. ", delay: 3030 },
        { type: 'text', text: "Il y a un gros probl\u00e8me de souris et la douche n'a que de l'eau froide. ", delay: 2970 },
        { type: 'text', text: "J'ai d\u00e9j\u00e0 connu des situations plus difficiles que celle-ci, ", delay: 3870 },
        { type: 'text', text: "mais j'aspire d\u00e9sesp\u00e9r\u00e9ment \u00e0 une vie normale et digne.", delay: 2180 },
        { type: 'text', text: '', delay: 4860 },
        { type: 'goToNext', delay: 910 },
      ],
      background: {
        src: hassanBG20,
        style: {}, //transition: 'left linear, top linear, width linear, height linear'
        animations: [
          { delay: 50, style: { animationDuration: '23100ms', animationName: 'scaleDown20' } }, // height: '120%', top: '-10%', width: '120%', left: '-10%'
        ],
      },
      // textBackgroundColor: '#af8d69',
      nextStepId: 'HASSAN 22',
    },
    {
      id: 'HASSAN 21',
      type: 'sequence',
      sound: HASSAN_FR_SEQ21,
      sound_delay: 50,
      sequence: [
        { type: 'text', text: 'Je d\u00e9cide de continuer \u00e0 chercher et, gr\u00e2ce au fr\u00e8re de Salim,', delay: 4090 },
        { type: 'text', text: 'je me retrouve dans une organisation \nqui aide les r\u00e9fugi\u00e9s \u00e0 trouver un endroit o\u00f9 vivre. ', delay: 3050 },
        { type: 'text', text: "Un jour, un volontaire m'appelle pour me dire que je dois venir imm\u00e9diatement.", delay: 4860 },
        { type: 'text', text: "Ils pensent m'avoir trouv\u00e9 un bon appartement. ", delay: 4000 },
        { type: 'text', text: 'Au moment de le visiter, c\u2019est le soulagement. ', delay: 2130 },
        { type: 'text', text: "Ce n'est pas le grand luxe mais c'est abordable, propre et facilement accessible.", delay: 2880 },
        { type: 'text', text: '', delay: 4650 },
        { type: 'goToNext', delay: 1080 },
      ],
      background: {
        src: hassanBG21,
        style: {},
        animations: [{ delay: 50, style: { animationDuration: '26160ms', animationName: 'scale20' } }],
      },
      // textBackgroundColor: '#af8d69',
      nextStepId: 'HASSAN 22',
    },
    //35
    {
      id: 'HASSAN 22',
      type: 'sequence',
      sound: HASSAN_FR_SEQ22,
      sound_delay: 50,
      sequence: [
        { type: 'text', text: 'Je vis en Belgique depuis un certain temps maintenant,', delay: 5010 },
        { type: 'text', text: 'mais c\u2019est comme si je n\u2019\u00e9tais pas vraiment l\u00e0. ', delay: 2070 },
        { type: 'text', text: 'Je parle jour et nuit avec mes amis et ma famille \nqui se trouvent aux quatre coins du monde.', delay: 2070 },
        { type: 'text', text: "Mon fr\u00e8re qui \u00e9tait dans l'arm\u00e9e a fui au Liban. ", delay: 4050 },
        { type: 'text', text: 'La maison de mon cousin dans le sud a \u00e9t\u00e9 compl\u00e8tement d\u00e9truite \n\u00e0 cause de la fusillade dans sa rue ', delay: 2920 },
        { type: 'text', text: 'et il vit maintenant en Autriche.', delay: 4090 },
        { type: 'text', text: 'Dans ma t\u00eate et dans mon c\u0153ur, je vis toujours dans une zone de guerre. ', delay: 2890 },
        { type: 'text', text: "C'est difficile de trouver mes rep\u00e8res. ", delay: 3940 },
        { type: 'text', text: 'Je ne connais pas beaucoup de gens ici. ', delay: 2110 },
        { type: 'text', text: "Certaines semaines, les conversations avec \nmon assistant social sont le seul contact humain que j'ai.", delay: 2040 },
        { type: 'text', text: "Il me conseille d'essayer de l\u00e2cher prise un moment:", delay: 5820 },
        { type: 'text', text: 'plus de lecture des nouvelles sur la Syrie, ', delay: 2230 },
        { type: 'text', text: 'plus de conversation Whatsapp avec ma famille et mes amis. ', delay: 1930 },
        { type: 'text', text: 'Est-ce que \u00e7a ne va pas me rendre compl\u00e8tement seul&thinsp;? ', delay: 3020 },
        { type: 'text', text: '', delay: 2500 },
        { type: 'goToNext', delay: 1500 },
      ],
      background: {
        src: baseBackgroundImg,
        // style: {}, //transition: 'left linear, top linear, width linear, height linear'
        // animations: [
        //   { delay: 50, style: { animationDuration: '37120ms', animationName: 'scale20' } }, // height: '120%', top: '-10%', width: '120%', left: '-10%'
        // ],
      },
      foreground: {
        src: phoneWhatsapp,
        style: { height: '60vh', opacity: 0 },
        animations: [{ delay: 7000, style: { animationName: 'animationHassanWhatsapp', animationDuration: '46190ms' } }],
      },
      // textBackgroundColor: '#af8d69',
      nextStepId: 'info_added_weird',
    },
    {
      id: 'HASSAN 23',
      type: 'sequence',
      sound: HASSAN_FR_SEQ23,
      sound_delay: 50,
      sequence: [
        { type: 'text', text: "Peut-\u00eatre est-ce parce que l'\u00e9t\u00e9 approche, ", delay: 4120 },
        { type: 'text', text: "peut-\u00eatre parce que la nuit derni\u00e8re j'ai r\u00eav\u00e9 en fran\u00e7ais pour la premi\u00e8re fois, ", delay: 2100 },
        { type: 'text', text: 'mais je commence \u00e0 me sentir mieux.', delay: 3820 },
        { type: 'text', text: "J'ose \u00e0 nouveau penser \u00e0 mon avenir.  ", delay: 2040 },
        { type: 'text', text: 'Je r\u00eave toujours de devenir biologiste', delay: 2090 },
        { type: 'text', text: 'mais mon assistant social pense \nqu\u2019il serait mieux d\u2019opter pour une formation courte. ', delay: 1900 },
        { type: 'text', text: 'Celle de laborantin semble int\u00e9ressant \nmais ce n\u2019est pas simple de s\u2019inscrire \u00e0 la haute \u00e9cole.', delay: 4110 },
        { type: 'text', text: "Comme je n'ai pas apport\u00e9 mon dipl\u00f4me d'enseignement secondaire de Syrie,", delay: 5000 },
        { type: 'text', text: 'je dois passer par toute une proc\u00e9dure \npour \u00eatre autoris\u00e9 \u00e0 commencer mes \u00e9tudes.', delay: 3050 },
        { type: 'text', text: "Mon fran\u00e7ais doit \u00e9galement \u00eatre bien meilleur qu'il ne l'est actuellement.", delay: 4840 },
        { type: 'text', text: 'Tout cela prend du temps et pendant ce temps, ', delay: 4000 },
        { type: 'text', text: "je ne gagne pas d'argent. ", delay: 1960 },
        { type: 'text', text: 'Je ne veux pas \u00eatre d\u00e9pendant des autres. ', delay: 1990 },
        { type: 'text', text: 'Je suis donc dans le doute. ', delay: 2060 },
        { type: 'text', text: "Devrais-je faire des \u00e9tudes au risque d'\u00eatre 4 ans sans revenu significatif&thinsp;? ", delay: 1140 },
        { type: 'text', text: 'Ou dois-je laisser mes \u00e9tudes de c\u00f4t\u00e9\net chercher un emploi imm\u00e9diatement&thinsp;?', delay: 3980 },
        { type: 'text', text: '', delay: 5020 },
        { type: 'goToNext', delay: 10 },
      ],
      background: {
        src: hassanBG23,
        style: {},
        animations: [{ delay: 50, style: { animationDuration: '53220ms', animationName: 'scale20' } }],
      },
      // textBackgroundColor: '#af8d69',
      nextStepId: 'info_final',
    },
    {
      id: 'choice_final',
      type: 'choice',

      ...base_choice_style,
      contentText:
        'Que ferais-tu à ma place&thinsp;?<br/>Est-ce que tu fe<span class="background-underlined large">rais des études,</span> au risque d’être 4 ans avec peu de revenu ? Ou choisirais-tu de cher<span class="background-underlined large">cher un travail</span> et laisser les études de côté&thinsp;?',
      choices: [
        {
          type: 'button',
          key: 'button-1',
          text: "S'inscrire à l'université des sciences appliquées",
          buttonStyle: choiceButtonStyle,
          action: 'goNext',
          nextStepId: 'epilogue_fin1',
          // action: 'showConfirmation',
          // confirmationContent: {
          //   title: '<span class="background-underlined large">Es-tu certain.e&thinsp;?</span>',
          //   buttons: [
          //     {
          //       text: 'Oui, je suis<br/>sûr.e de moi',
          //       buttonStyle: choiceButtonStyle,
          //       action: 'goNext',
          //       nextStepId: 'epilogue_fin1',
          //     },
          //     {
          //       text: 'Je reviens<br/>sur ma décision',
          //       buttonStyle: choiceButtonStyle,
          //       action: 'closeConfirmation',
          //     },
          //   ],
          // },
        },
        {
          type: 'button',
          key: 'button-2',
          text: 'Chercher un emploi',
          buttonStyle: choiceButtonStyle,
          action: 'goNext',
          nextStepId: 'epilogue_fin2',
          // action: 'showConfirmation',
          // confirmationContent: {
          //   title: '<span class="background-underlined large">Es-tu certain.e&thinsp;?</span>',
          //   buttons: [
          //     {
          //       text: 'Oui, je suis<br/>sûr.e de moi',
          //       buttonStyle: choiceButtonStyle,
          //       action: 'goNext',
          //       nextStepId: 'epilogue_fin2',
          //     },
          //     {
          //       text: 'Je reviens<br/>sur ma décision',
          //       buttonStyle: choiceButtonStyle,
          //       action: 'closeConfirmation',
          //     },
          //   ],
          // },
        },
      ],
    },
    {
      id: 'epilogue_fin1',

      ...base_epilogue,

      sound: HASSAN_FR_EPILOGFIN1,
      sound_delay: epilogeAnimationTiming + epilogeSoundAdditionalDelay,
      sequence: [
        {
          delay: epilogeAnimationTiming,
          title: 'Voici à quoi ressemble ma vie en Belgique',
          text: "Je décide de le faire ! Je vais étudier les sciences de laboratoire et je réalise ainsi mon rêve initial de devenir biologiste. C'est très difficile. Mon français est loin d'être assez bon. J'ai quelques amis à l'université qui m'aident, mais c'est toujours difficile. En plus de mes études, j'essaie de travailler autant que possible pour gagner suffisamment d'argent. Je suis heureux d'avoir suivi mon cœur. Je rêve de la Syrie tout le temps. Ma Syrie. La guerre continue là-bas. Les gens y vivent toujours dans la terreur quotidienne. Mon cœur se brise quand je pense à ma famille et à mes amis qui sont encore là-bas.",
          textStyle: { left: '45vw' },
        },
      ],
      nextStepId: 'other_choices',
    },
    {
      id: 'epilogue_fin2',

      ...base_epilogue,

      sound: HASSAN_FR_EPILOGFIN2,
      sound_delay: epilogeAnimationTiming + epilogeSoundAdditionalDelay,
      sequence: [
        {
          delay: epilogeAnimationTiming,
          title: 'Voici à quoi ressemble ma vie en Belgique',
          text: "C'est trop risqué. 4 ans sans un bon revenu ? Que se passe-t-il si quelque chose arrive à ma famille en Syrie et que mes parents ont soudainement besoin d'argent ? Je postule pour un emploi dans une entreprise de construction du quartier et je suis embauché très rapidement. Le travail est dur mais au moins je gagne de l'argent. Je rêve de la Syrie. Ma Syrie. Les combats continuent là-bas. Des gens y vivent toujours dans la terreur quotidienne. Mon cœur se brise quand je pense à ma famille et à mes amis qui sont encore là-bas.",
          textStyle: { left: '45vw' },
        },
      ],
      nextStepId: 'other_choices',
    },
    //40
    {
      ...base_choice_style,
      id: 'info1',
      type: 'info',

      contentText:
        'Que <span class="background-underlined medium">ferais-tu</span> à ma place&thinsp;?<br/>Dénoncer cette injustice et <span class="background-underlined large">partager la vi</span>déo sur les réseaux sociaux ou jouer la prudence et <span class="background-underlined very-large">ne rien faire</span>&thinsp;?',
      actionText: 'Je m’informe pour aider Hassan à prendre la bonne décision :',
      actions: [
        {
          type: 'button',
          key: 'button-watch-1',
          text: 'Je regarde le témoignage de Mohamed.',
          buttonStyle: { '&:hover': { color: colors.violet } },
          icon: boutonRegarder,
          iconHover: boutonRegarderHoover,
          action: 'openDialog',
          dialogContent: {
            transition: 'slideUp',
            type: 'video',
            videoIframe: getYoutubeIframe('VLlW37N4Yzk'),
          },
        },
        {
          type: 'button',
          key: 'button-watch-2',
          text: 'Je regarde l’interview d’un expert sur la liberté d’expression en Syrie. ',
          buttonStyle: { '&:hover': { color: colors.violet } },
          icon: boutonRegarder,
          iconHover: boutonRegarderHoover,
          action: 'openDialog',
          dialogContent: {
            transition: 'slideUp',
            type: 'video',
            videoIframe: getYoutubeIframe('rM4QZPP8Gw0'),
          },
        },
      ],
      nextButtonStyle: {
        '&:hover': { color: colors.violet },
      },
      nextButtonText: 'Prendre une décision >',
      nextStepId: 'choice1',
    },
    {
      ...base_choice_style,
      id: 'info2',
      type: 'info',

      contentText:
        'J’hésite, qu’est-ce <span class="background-underlined very-large">que tu ferais, to</span>i&thinsp;?<br/>Rest<span class="background-underlined large">erais-tu en Syrie</span> en te cachant chez ton cousin ? Ou <span class="background-underlined large">fuirais-tu</span> immédiatement en Turquie par sécurité ?',
      actionText: 'Je m’informe pour aider Hassan à prendre la bonne décision :',
      actions: [
        {
          type: 'button',
          key: 'button-watch-1',
          text: 'Je regarde le témoignage de Mohamed sur sa fuite de Syrie ',
          buttonStyle: { '&:hover': { color: colors.violet } },
          icon: boutonRegarder,
          iconHover: boutonRegarderHoover,
          action: 'openDialog',
          dialogContent: {
            transition: 'slideUp',
            type: 'video',
            videoIframe: getYoutubeIframe('C0l4l-GY2W0'),
          },
        },
        {
          type: 'button',
          key: 'button-watch-2',
          text: 'Je regarde la vidéo du UNHCR sur les personnes déplacées internes',
          buttonStyle: { '&:hover': { color: colors.violet } },
          icon: boutonRegarder,
          iconHover: boutonRegarderHoover,
          action: 'openDialog',
          dialogContent: {
            transition: 'slideUp',
            type: 'video',
            videoIframe: getYoutubeIframe('MtnI6Y1ORos'),
          },
        },
      ],
      nextButtonStyle: {
        '&:hover': { color: colors.violet },
      },
      nextButtonText: 'Prendre une décision >',
      nextStepId: 'choice2',
    },
    {
      ...base_choice_style,
      id: 'info4',
      type: 'info',

      contentText:
        'Quel dilemme! Que ferais-<span class="background-underlined large">tu à ma place</span>&thinsp;?<br/>Rejoindrais-tu <span class="background-underlined very-large">l’armée gouvernementale</span> ou laisserais-tu tout le monde derrière toi pour <span class="background-underlined large">fuir en Turquie</span>&thinsp;?',
      actionText: 'Je m’informe pour aider Hassan à prendre la bonne décision :',
      actions: [
        {
          type: 'button',
          key: 'button-watch-1',
          text: 'Je regarde l’interview d’un expert sur le service militaire en Syrie',
          buttonStyle: { '&:hover': { color: colors.violet } },
          icon: boutonRegarder,
          iconHover: boutonRegarderHoover,
          action: 'openDialog',
          dialogContent: {
            transition: 'slideUp',
            type: 'video',
            videoIframe: getYoutubeIframe('05ziK19zEFU'),
          },
        },
        {
          type: 'button',
          key: 'button-watch-2',
          text: 'Je regarde le témoignage de Mohamed sur la raison pour laquelle il est parti',
          buttonStyle: { '&:hover': { color: colors.violet } },
          icon: boutonRegarder,
          iconHover: boutonRegarderHoover,
          action: 'openDialog',
          dialogContent: {
            transition: 'slideUp',
            type: 'video',
            videoIframe: getYoutubeIframe('T0yYIPpGlIc'),
          },
        },
      ],
      nextButtonStyle: {
        '&:hover': { color: colors.violet },
      },
      nextButtonText: 'Prendre une décision >',
      nextStepId: 'choice4',
    },
    {
      ...base_choice_style,
      id: 'info3',
      type: 'info',

      contentText:
        'Quel dilemme! Que ferais-<span class="background-underlined large">tu à ma place</span>&thinsp;?<br/>Rejoindrais-tu <span class="background-underlined very-large">l’armée gouvernementale</span> ou laisserais-tu tout le monde derrière toi pour <span class="background-underlined large">fuir en Turquie</span>&thinsp;?',
      actionText: 'Je m’informe pour aider Hassan à prendre la bonne décision :',
      actions: [
        {
          type: 'button',
          key: 'button-watch-1',
          text: 'Je regarde l’interview d’un expert sur le service militaire en Syrie',
          buttonStyle: { '&:hover': { color: colors.violet } },
          icon: boutonRegarder,
          iconHover: boutonRegarderHoover,
          action: 'openDialog',
          dialogContent: {
            transition: 'slideUp',
            type: 'video',
            videoIframe: getYoutubeIframe('05ziK19zEFU'),
          },
        },
        {
          type: 'button',
          key: 'button-watch-2',
          text: 'Je regarde le témoignage de Mohamed sur la raison pour laquelle il est parti',
          buttonStyle: { '&:hover': { color: colors.violet } },
          icon: boutonRegarder,
          iconHover: boutonRegarderHoover,
          action: 'openDialog',
          dialogContent: {
            transition: 'slideUp',
            type: 'video',
            videoIframe: getYoutubeIframe('T0yYIPpGlIc'),
          },
        },
      ],
      nextButtonStyle: {
        '&:hover': { color: colors.violet },
      },
      nextButtonText: 'Prendre une décision >',
      nextStepId: 'choice3',
    },
    {
      ...base_choice_style,
      id: 'infoEurope',
      type: 'info',

      contentText:
        'Je ne sais vraiment pas ce que je dois faire. Qu’est-ce que tu ferais si tu étais dan<span class="background-underlined medium">s mes chaussur</span>es&thinsp;?<br/>Acompagnerais-tu Sali<span class="background-underlined large">m en Europe</span> en risquant ta vie ? Ou resterais-tu s<span class="background-underlined large">eul·e en Turquie</span> en espérant pouvoir y avoir tout de même une vie décente&thinsp;?',
      actionText: 'Je m’informe pour aider Hassan à prendre la bonne décision :',
      actions: [
        {
          type: 'button',
          key: 'button-read-1',
          text: 'Je lis le rapport d’Amnesty International sur les pushbacks (personnes qui sont refoulées illégalement) en Grèce',
          buttonStyle: { '&:hover': { color: colors.violet } },
          icon: boutonLire,
          iconHover: boutonLireHoover,
          action: 'openDialog',
          dialogContent: {
            transition: 'slideUp',
            backgroundImage: backgoundPurple,
            type: 'text',
            title: "Rapport d’Amnesty International sur les pushbacks et la violence le long de la frontière grecque<br/><span class='subtitle'>Résumé du rapport</span>",
            text: 'Ce rapport se base sur des entretiens avec des personnes ayant subi des pushbacks. On estime qu’un millier de personnes au total ont été victimes de ces expulsions illégales. <span class="inline-title">UNE PRATIQUE BIEN ANCRÉE</span>Ce rapport se concentre sur la région autour du fleuve Evros, à la frontière avec la Turquie, entre mars et décembre 2020. Cette nouvelle enquête montre que les violations de droits humains sont désormais une pratique bien ancrée des garde-côtes grecs. “Le degré d’organisation nécessaire pour procéder à ces renvois [à cette échelle] indique jusqu’où va la Grèce pour renvoyer illégalement des personnes et couvrir ses agissements” selon Adriana Tidona, spécialiste des migrations.<span class="inline-title">BATTU·E·S ET HUMILIÉ·E·S </span>La grande majorité des personnes ont été soumises ou ont assisté à des violences perpétrées par des personnes qu\'elles ont décrites comme de représentants de l’état grec en uniforme et des hommes en civil. Elles ont reçu des coups de bâton ou de matraque, des coups de pied, ou ont été poussées, ce qui a parfois entrainé des blessures graves. Les hommes ont souvent été soumis à des fouilles nues humiliantes et agressives, parfois sous les yeux de femmes et d’enfants.  <span class="inline-title">TORTURE</span>Certains actes s’apparentaient à de la torture, compte tenu de leur gravité et de leur caractère humiliant ou punitif. Ainsi, un homme syrien raconte comment des “soldats” vêtus de noir et encagoulés avaient ramené son groupe au fleuve Evros. Une personne qui a tenté de s’échapper a été tellement rouée de coups que sa colonne vertébrale semblait fracturée : “Il ne pouvait plus bouger du tout, même pas les mains”. Un autre raconte comment un homme qui ne savait pas nager a quand même été forcé à plonger dans l’eau. Cet homme a été emporté par le courant.<br/></br>Résumé du rapport d’Amnesty International <a href="https://www.amnesty-international.be/sites/default/files/bijlagen/greece-violence_lies_and_pushbacks_2021.pdf" target="_blank">“Greece: Violence, lies, and pushbacks”</a> de 2021',
          },
        },
        {
          type: 'button',
          key: 'button-read-2',
          text: 'Je lis un article qui témoigne de la vie de Syrien·ne·s en Turquie',
          buttonStyle: { '&:hover': { color: colors.violet } },
          icon: boutonLire,
          iconHover: boutonLireHoover,
          action: 'openDialog',
          dialogContent: {
            transition: 'slideUp',
            backgroundImage: backgoundPurple,
            type: 'text',
            title: "Syrien·ne·s d’Istanbul, une existence en exil<br/><span class='subtitle'>MO* magazine (résumé de l’article original d’Arthur Debruyn)</span>",
            text: '<span class="inline-title">IMPITOYABLES PATRONS TURCS</span>Nous parlons à Housam Mehdin (40 ans), père de six enfants et originaire d’Alep en Syrie, lorsqu’il rentre chez lui à midi pour boire du thé et prier. “Heureusement j’ai un travail dans le quartier, donc je peux être avec ma femme un instant. Mais je dois veiller à ne pas avoir une minute de retard au travail parce que les patrons turcs sont impitoyables avec les Syrien·ne·s”. Mehdin raconte le même récit d’exploitation au travail que beaucoup de ses compatriotes. Presque sans exception, les Syrien·ne·s sont payé·e·s jusqu’à deux fois moins que leurs collègues turcs. “Les patrons savent que nous resterons coûte que coûte, et qu’il y a toujours quelqu’un de prêt à nous remplacer” poursuit-il. “Ils jouent là-dessus, et nous n’avons pas d’autre choix que de le supporter”.  Le gouvernement turc annonce des permis de travail et un salaire minimum pour les Syrien·ne·s, mais les patrons ignorent cette politique. “Quand l\'inspection arrive, on doit mentir" ajoute Mehdin. C’est la principale raison pour laquelle de nombreuses familles retirent leurs enfants mineurs de l’école et les mettent au travail. Comme les salaires des Syrien·ne·s sont souvent en dessous du salaire minimum, toute la famille doit contribuer pour joindre les deux bouts. C’est aussi le cas de la famille Mehdin: à leur arrivée il y a deux ans et demi, leur fille Nuran, qui n’avait pas encore 12 ans, avait été obligée d’aller travailler, emballant des bonbons tous les jours.<span class="inline-title">DORMIR, TRAVAILLER, MANGER, RECOMMENCER</span>Houssan Mehdin a de la chance que lui et sa famille parviennent encore à s’en sortir. De nombreux jeunes hommes isolés arrivent à peine à garder la tête hors de l’eau. Partout à Istanbul, des adolescents et des jeunes dans la vingtaine, originaire de Homs, Alep, Idlib et Raqqa entre autres, vivent entassés -parfois avec des dizaines d’autres- dans des appartements humides et insalubres en sous-sol.<br/></br>La vie en Turquie ? Une vie de labeur, ils sont unanimes à ce sujet. “Dormir, travailler, manger et recommencer” dit Abdallah Bakir (23 ans) d’Idlib. Il partage un sous-sol avec ses frères Sahir (21 ans) et Ali (27 ans) et dix-neuf autres personnes à Esenler, une banlieue d’Istanbul. Comme la plupart de ses colocataires, Bagir travaille dans le quartier textile adjacent. “Nous sommes tous terriblement sous-payés” explique-t-il. “Nous travaillons comme des bêtes et gagnons juste assez pour survivre et mettre une centaine de dollars de côté chaque mois pour le bateau vers l’Europe”. Est-ce donc tellement mieux là-bas ? “Oui, c’est ce que disent tous nos amis qui ont réussi, ils travaillent seulement huit heures et gagnent un salaire correct. Là-bas, il est possible d’avoir une vie digne. La vie en Turquie est sans issue. Si nous ne partons pas le plus vite possible, nous allons nous effondrer”. <span class="inline-title">AVENIR SANS ISSUE</span>A côté de lui, sur le banc, se trouve un garçon de seize ans qui est seul en Turquie. Son école secondaire à Raqqa a été fermée par l’Etat Islamique et remplacée par une école coranique, dit-il. Ce sont tous des garçons issus de familles syriennes de classe moyenne ou même riches, qui ont déserté l’armée du régime et qui veulent étudier ou apprendre un métier. Leurs yeux expriment de la résignation. Ils travaillent six jours sur sept, au moins douze heures par jour. La seule porte de sortie qu’ils connaissent est un bateau vers une des îles grecques.<br/><br/>Cet article est un résumé d’extraits de l’article de Mo* Magazine <a href="https://www.mo.be/analyse/syri-rs-van-istanboel-een-bestaan-ballingschap" target="_blank">“Syriërs van Istanboel, een bestaan in ballingschap”</a> publié le 24 mars 2016.',
          },
        },
      ],
      nextButtonStyle: {
        '&:hover': { color: colors.violet },
      },
      nextButtonText: 'Prendre une décision >',
      nextStepId: 'choiceEurope',
    },
    //45
    {
      ...base_choice_style,
      id: 'infoResterFinalementTurquie',
      type: 'info',

      contentText:
        'Je ne sais plus ce que je dois faire. Que ferais-tu <span class="background-underlined very-large">si tu étais moi</span>&thinsp;? Rest<span class="background-underlined very-large">erais-tu en Turquie</span> et essaierais-tu d’être heureux·se ici? Ou essaierais-tu quand même d’all<span class="background-underlined medium">er en Euro</span>pe?',
      actionText: 'Je m’informe pour aider Hassan à prendre la bonne décision :',
      actions: [
        {
          type: 'button',
          key: 'button-read-1',
          text: 'Je lis un extrait du rapport du UNHCR sur les conditions de vie sur les îles grecques',
          buttonStyle: { '&:hover': { color: colors.violet } },
          icon: boutonLire,
          iconHover: boutonLireHoover,
          action: 'openDialog',
          dialogContent: {
            transition: 'slideUp',
            backgroundImage: backgoundPurple,
            type: 'text',
            title: '“Ils ont tout pris”',
            text: 'Zemar* n’avait que 15 ans lorsqu’il est arrivé d’Afghanistan au centre d’accueil de Moria sur l’île grecque de Lesbos. Il avait survécu à une série d’expériences traumatisantes et venait d’être séparé de ses parents. Il avait besoin de repos.<br/>La première nuit, son sac a été volé. Il se sentait encore plus seul. “Ils ont tout pris” dit-il. “Je n’avais personne à qui parler”.<br/><br/>Quelques nuits plus tard, trois hommes l’ont attaqué. Il a réussi à s’échapper et à rejoindre une patrouille de police à l’entrée principale de Moria. Il a passé cette nuit sur le trottoir, en sécurité, mais incapable d’expliquer aux officiers ce qu’il s’était passé, faute d’interprète. <span class="inline-title">ENFANTS ISOLÉS</span>Les conditions de vie sont devenues effroyables pour les demandeur·se·s de protection internationale dans le centre d’accueil de Moria, qui accueille à présent 12 800 personnes – soit cinq fois sa capacité. Les gens dorment dans des containeurs et des tentes dans une oliveraie adjacente. Presque 1 000 enfants, surtout des adolescent·e·s, vivent à Moria sans leurs parents ni membres de leur famille. La moitié d’entre eux sont logés dans quatre sections protégées, mais les autres dorment dans un entrepôt en toile, appelé Rubb Hall, où logent également des adultes. <br/>Dans les îles grecques de la mer Égée, plus de 1 600 mineurs non accompagnés résident dans des structures d’accueil tels que Moria, gérées par le gouvernement.<br/><br/>Dans le centre d’accueil de Vathy sur l’île de Samos, plus d’une douzaine de filles isolées dorment à tour de rôle dans un petit container, pendant que d’autres enfants dorment sur les toits des containers. Les enfants isolés peuvent vivre dans des conditions non sécurisées pendant des mois en attendant d’être hébergés. Cela les affecte mentalement et physiquement. <br/>“Nous nous sentons toutes et tous inutiles... J’ai tellement de stress. Je perds ma mémoire. Quand j’essaie de dormir, j’ai chaque fois des cauchemars. Je veux juste revoir ma famille” dit Zemar.<br/><br/>Il y a aujourd’hui plus de 4 600 demandeur·se·s de protection internationale mineur·e·s et sans parents en Grèce, le nombre le plus élevé depuis 2016. Seul un·e jeune sur quatre est hébergé·e dans un centre d’accueil adapté pour son âge, et plus de 1 000 sont sans abri ou vivent sous tente. Zemar a fui l’Afghanistan avec sa famille après que les Talibans ont tué son frère ainé pour avoir collaboré avec les autorités afghanes. Il a été séparé de ses parents sur une plage turque, lorsque les passeurs essayaient de les embarquer avec un groupe de 50 autres personnes à bord d’un petit canot pneumatique, au milieu de la nuit. Certaines personnes n’ont pas grimpé assez vite et sont restées derrière.<br/><br/>*Prénom modifié pour des raisons de sécurité<br/><br/>Extrait du rapport du UNHCR <a href="https://data2.unhcr.org/en/documents/details/71703#_ga=2.86246424.1887737415.1629278509-1074422688.1629278509" target="_blank">“Desperate Journeys”</a> publié sur la page internet du UNHCR le 15 octobre 2019.',
          },
        },
      ],
      nextButtonStyle: {
        '&:hover': { color: colors.violet },
      },
      nextButtonText: 'Prendre une décision >',
      nextStepId: 'choiceResterFinalementTurquie',
    },
    {
      ...base_choice_style,
      id: 'info_retour_volontaire',
      type: 'info',

      contentText:
        'Je ne sais vraiment plus quoi faire. Que ferais-tu à ma place ?<br/>Continuerais-tu à patienter même si tu as le sentiment <span class="background-underlined large">de devenir fou</span> et que ta famille te manque terriblement ? Ou essaierais-tu de retou<span class="background-underlined large">rner en Syrie</span>&thinsp;?',
      actionText: 'Je m’informe pour aider Hassan à prendre la bonne décision :',

      actions: [
        {
          type: 'button',
          key: 'button-watch-1',
          text: 'Je regarde l’interview d’un expert sur la situation actuelle en Syrie',
          buttonStyle: { '&:hover': { color: colors.violet } },
          icon: boutonRegarder,
          iconHover: boutonRegarderHoover,
          action: 'openDialog',
          dialogContent: {
            transition: 'slideUp',
            type: 'video',
            videoIframe: getYoutubeIframe('oW14-bIKFzc'),
          },
        },
        {
          type: 'button',
          key: 'button-watch-2',
          text: 'Je regarde l’interview d’un expert sur ce qui est difficile à vivre pour les jeunes réfugié·e·s',
          buttonStyle: { '&:hover': { color: colors.violet } },
          icon: boutonRegarder,
          iconHover: boutonRegarderHoover,
          action: 'openDialog',
          dialogContent: {
            transition: 'slideUp',
            type: 'video',
            videoIframe: getYoutubeIframe('se5fbUsE6b8'),
          },
        },
      ],
      nextButtonStyle: {
        '&:hover': { color: colors.violet },
      },
      nextButtonText: 'Prendre une décision >',
      nextStepId: 'choice_retour_volontaire',
    },
    {
      ...base_choice_style,
      id: 'info_appartement',
      type: 'info',

      contentText:
        'Que dois-je décider&thinsp;? Que ferais-tu, toi&thinsp;? <br/>Signer<span class="background-underlined large">ais-tu le contrat</span> pour être sûr·e de ne pas devoir dormir dehors ? Ou cherc<span class="background-underlined very-large">herais-tu encore un pe</span>u en espérant trouver quelque-chose de mieux ?',
      actionText: 'Je m’informe pour aider Hassan à prendre la bonne décision :',

      actions: [
        {
          type: 'button',
          key: 'button-watch-1',
          text: 'Je regarde le témoignage de Mohamed de Palestine sur sa recherche de logement',
          buttonStyle: { '&:hover': { color: colors.violet } },
          icon: boutonRegarder,
          iconHover: boutonRegarderHoover,
          action: 'openDialog',
          dialogContent: {
            transition: 'slideUp',
            type: 'video',
            videoIframe: getYoutubeIframe('5eHVamjIPUM'),
          },
        },
        {
          type: 'button',
          key: 'button-watch-2',
          text: 'Je regarde l’interview d’un expert sur la difficulté de trouver un logement',
          buttonStyle: { '&:hover': { color: colors.violet } },
          icon: boutonRegarder,
          iconHover: boutonRegarderHoover,
          action: 'openDialog',
          dialogContent: {
            transition: 'slideUp',
            type: 'video',
            videoIframe: getYoutubeIframe('DY9LMZ_G60Y'),
          },
        },
      ],
      nextButtonStyle: {
        '&:hover': { color: colors.violet },
      },
      nextButtonText: 'Prendre une décision >',
      nextStepId: 'choice_appartement',
    },
    {
      ...base_choice_style,
      id: 'info_final',
      type: 'info',

      contentText:
        'Que ferais-tu à ma place&thinsp;?<br/>Est-ce que tu fe<span class="background-underlined large">rais des études,</span> au risque d’être 4 ans avec peu de revenu ? Ou choisirais-tu de cher<span class="background-underlined large">cher un travail</span> et laisser les études de côté&thinsp;?',
      actionText: 'Je m’informe pour aider Hassan à prendre la bonne décision :',
      actions: [
        {
          type: 'button',
          key: 'button-ask',
          text: 'Je demande à Hassan ce que lui dit son coeur',
          buttonStyle: { '&:hover': { color: colors.violet } },
          icon: boutonCoeur,
          iconHover: boutonCoeurHoover,
          action: 'openDialog',
          dialogContent: {
            type: 'image',
            imageSrc: PhylactereHassan,
            imageStyle: { marginBottom: '15vh', width: '30vw', maxWidth: '400px', height: 'auto', maxHeight: '50vh', objectFit: 'contain', objectPosition: 'center' },
          },
        },
      ],
      nextButtonStyle: {
        '&:hover': { color: colors.violet },
      },
      nextButtonText: 'Prendre une décision >',
      nextStepId: 'choice_final',
    },
    {
      ...base_choice_style,
      id: 'info_added_weird',
      type: 'info',

      contentText:
        'Que ferais-tu, toi, dans cette situation&thinsp;?<br/>Est-ce que tu coupe<span class="background-underlined very-large">rais temporairement les pont</span>s avec ta famille pour pouvoir pleinement te focaliser sur la Belgique ? Ou est-ce ça rendrait au contraire les choses p<span class="background-underlined medium">lus difficile</span>s&thinsp;?',
      actionText: 'Je m’informe pour aider Hassan à prendre la bonne décision :',
      actions: [
        {
          type: 'button',
          key: 'button-watch-1',
          text: 'J’écoute le témoignage de Mohamed de Palestine sur les moments difficiles qu’il a eu en Belgique',
          buttonStyle: { '&:hover': { color: colors.violet } },
          icon: boutonRegarder,
          iconHover: boutonRegarderHoover,
          action: 'openDialog',
          dialogContent: {
            transition: 'slideUp',
            type: 'video',
            videoIframe: getYoutubeIframe('ir2-LdQvlcA'),
          },
        },
        {
          type: 'button',
          key: 'button-watch-2',
          text: 'J’écoute le témoignage d’un réfugié syrien sur ce qui a été difficile pour lui',
          buttonStyle: { '&:hover': { color: colors.violet } },
          icon: boutonRegarder,
          iconHover: boutonRegarderHoover,
          action: 'openDialog',
          dialogContent: {
            transition: 'slideUp',
            type: 'video',
            videoIframe: getYoutubeIframe('flfxWQHu2o8'),
          },
        },
      ],
      nextButtonStyle: {
        '&:hover': { color: colors.violet },
      },
      nextButtonText: 'Prendre une décision >',
      nextStepId: 'choice_added_weird',
    },
    {
      id: 'choice_added_weird',
      type: 'choice',

      ...base_choice_style,
      contentText:
        'Que ferais-tu, toi, dans cette situation&thinsp;?<br/>Est-ce que tu coupe<span class="background-underlined very-large">rais temporairement les pont</span>s avec ta famille pour pouvoir pleinement te focaliser sur la Belgique ? Ou est-ce ça rendrait au contraire les choses p<span class="background-underlined medium">lus difficile</span>s&thinsp;?',
      choices: [
        {
          type: 'button',
          key: 'button-1',
          text: 'Couper temporairement les ponts',
          buttonStyle: choiceButtonStyle,
          action: 'goNext',
          nextStepId: 'HASSAN 23',
        },
        {
          type: 'button',
          key: 'button-2',
          text: 'Maintenir le contact',
          buttonStyle: choiceButtonStyle,
          action: 'goNext',
          nextStepId: 'HASSAN 23',
        },
      ],
    },
    {
      id: 'mapIncoherence1',
      type: 'map',
      background: baseBackgroundImg,
      mapImage: mapIncoherence1,
      mapImageStyle: { maxWidth: '1500px', width: '80vw', height: 'auto' },
      mapContainerClass: 'cursor-gray',
      nextStepDelay: 3500,
      nextStepId: 'HASSAN 14',
    },
  ],
};
